// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T21:12:06.785Z
// Property: LPM Apartments (ID: 6737460151191502)
// Collections: 64 amenities, 18 floorplans (live), 35 photos, 80 POIs, 5 reviews, 1 virtual tours, 6 office hours, 1 special offers (live), 1 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6737460151191502",
  "property_external_id": "1676941",
  "property_zillow_url": "https://www.zillow.com/apartments/minneapolis-mn/lpm-apartments/5gkW5R/",
  "property_apartments_url": "https://www.apartments.com/lpm-apartments-minneapolis-mn/htc4991",
  "property_google_business_url": "https://www.google.com/maps/place/LPM/data=!4m2!3m1!1s0x0:0xe04178939e88ada3?sa=X&ved=2ahUKEwi0k9S10LmSAxX4IkQIHZVLJ9UQ_BJ6BAg7EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "15684310279",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "lpm-apartments",
  "property_name": "LPM Apartments",
  "property_website_url": "https://www.lpmapartments.com/",
  "property_domain": "https://www.lpmapartments.com/",
  "property_address": "1369 Spruce Pl",
  "property_full_address": "1369 Spruce Pl, Minneapolis, MN 55403",
  "property_address_1": "1369 Spruce Pl",
  "property_address_2": null,
  "property_address_city": "Minneapolis",
  "property_address_state": "MN",
  "property_address_zip_full": "55403",
  "property_address_zip": "55403",
  "property_address_country": "US",
  "property_address_county": "Hennepin County",
  "property_neighborhood_address": "Central Minneapolis",
  "property_address_latitude": "44.9691334",
  "property_address_longitude": "-93.28008589999999",
  "property_email": "LPM@weidner.com",
  "property_phone": "(833) 695-1066",
  "property_call_tracking_phone": "612-482-8616",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p>Come home to relaxed, elegant living at LPM Apartments. Our apartments in Minneapolis’s Loring Park neighborhood are in a vibrant area near the Minneapolis Convention Center, Gaviidae Common Mall, U.S. Bank Stadium, and Target Center. LPM Apartments offers modern apartments with useful amenities in an active community. It’s also pet-friendly, has a parking garage, and provides easy access to the Metro Transit, I-94/394, and I-35 E/W.</p>",
  "property_long_description": "<p>Come home to relaxed, elegant living at LPM Apartments. Our apartments in Minneapolis’s Loring Park neighborhood are in a vibrant area near the Minneapolis Convention Center, Gaviidae Common Mall, U.S. Bank Stadium, and Target Center. LPM Apartments offers modern apartments with useful amenities in an active community. It’s also pet-friendly, has a parking garage, and provides easy access to the Metro Transit, I-94/394, and I-35 E/W.</p><p>Situated among Loring Park’s lush walking trails and scenic byway, LPM Apartments is an energetic high-rise community in downtown Minneapolis. From the glass-paneled balconies to the two designer-finish packages available, each home offers a sophisticated and unique living experience. Outside your front door and within the LEED Silver Design community, you’ll find amenities like outdoor event spaces, pool cabanas and rooftop games.</p><p>Venture outside and explore trendy nearby neighborhoods, including North Loop and Uptown. You’ll also enjoy convenient commutes thanks to the community’s ideal Loring Park location near Metro Transit bus stops, I-394, I-94 and 35W and the Central Business District. Call today to learn more about these one-of-a-kind apartments in Minneapolis, MN.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d1f-93d2-716d-9c96-dbe798c45dcb.webp",
  "property_featured_image_media": {
    "alt_text": "LPM Apartments reception desk with agate-inlaid front and property logo.",
    "public_id": "01a10d1f-93d2-716d-9c96-dbe798c45dcb",
    "storage_key": "property/6737460151191502/01a10d1f-93d2-716d-9c96-dbe798c45dcb.webp",
    "width": 3072,
    "height": 2046
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "358",
  "property_year_built": "2014",
  "property_year_renovated": null,
  "property_walk_score": "94",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "91.89944134078212",
  "property_admin_fee": "175",
  "property_application_fee": "50",
  "property_fees_deposit_info": "Security deposit: $500",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "Varies",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://lpmapartments.securecafe.com/onlineleasing/lpm-apartments-0/floorplans.aspx",
  "property_resident_portal_url": "https://lpmapartments.securecafenet.com/residentservices/lpm-apartments-0/userlogin",
  "property_apply_now_url": "https://lpmapartments.securecafe.com/onlineleasing/lpm-apartments-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03fda-61b9-779c-be9f-156bc55a3327.webp",
  "property_primary_logo_media": {
    "alt_text": "LPM Apartments logo",
    "public_id": "01a03fda-61b9-779c-be9f-156bc55a3327",
    "storage_key": "property/6737460151191502/01a03fda-61b9-779c-be9f-156bc55a3327.webp",
    "width": 400,
    "height": 345
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01aa-8d63-70dc-8060-a1393bc5bd7d.webp",
  "property_secondary_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d01aa-8d63-70dc-8060-a1393bc5bd7d",
    "storage_key": "property/6737460151191502/019d01aa-8d63-70dc-8060-a1393bc5bd7d.webp",
    "width": 325,
    "height": 97
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-2570-77df-bcba-a525da05f589.webp",
  "property_mono_white_logo_media": {
    "alt_text": "LPM Apartments logo",
    "public_id": "019d01a7-2570-77df-bcba-a525da05f589",
    "storage_key": "property/6737460151191502/019d01a7-2570-77df-bcba-a525da05f589.webp",
    "width": 400,
    "height": 345
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03fda-8b29-7623-b496-a6143b594cfe.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a03fda-8b29-7623-b496-a6143b594cfe",
    "storage_key": "property/6737460151191502/01a03fda-8b29-7623-b496-a6143b594cfe.webp",
    "width": 400,
    "height": 345
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#192944",
  "property_secondary_color": "#CBC4BC",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 3",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "674 - 2056",
  "property_sqft_min": "674",
  "property_sqft_max": "2056",
  "property_price_range": "1300 - 7340",
  "property_price_min": "1395",
  "property_price_max": "7500",
  "property_available_units": 29,
  "property_facebook_url": "https://www.facebook.com/LPMApartmentHomes/",
  "property_instagram_url": "https://www.instagram.com/lpmapartmenthomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJcw9lfMAys1IRo62InpN4QeA",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to LPM Apartments",
  "property_home_romance_title": "Pairing flexibility with style, luxurious downtown views, and the best in modern living",
  "property_home_amenities_blurb": "<p>Situated among Loring Park’s lush walking trails and scenic byway, LPM Apartments is an energetic high-rise community in downtown Minneapolis. From the glass-paneled balconies to the two designer-finish packages available, each home offers a sophisticated and unique living experience. Outside your front door and within the LEED Silver Design community, you’ll find amenities like outdoor event spaces, pool cabanas and rooftop games.</p>",
  "property_home_floorplans_blurb": "<p><strong>High-rise layouts with downtown energy.</strong><br>Choose from studios, one-, two-, and three-bedroom residences, plus penthouse floor plans with extra room to stretch out. LPM Apartments pairs polished interiors with floor-to-ceiling windows, open kitchens with stainless steel appliances and gas ranges, full-size washer/dryer sets, generous closets, and select glass-paneled balconies with city views.</p>",
  "property_home_gallery_blurb": "<p>Venture outside and explore trendy nearby neighborhoods, including North Loop and Uptown. You’ll also enjoy convenient commutes thanks to the community’s ideal Loring Park location near Metro Transit bus stops, I-394, I-94 and 35W and the Central Business District. Call today to learn more about these one-of-a-kind apartments in Minneapolis, MN.</p>",
  "property_home_neighborhood_blurb": "<p>Located at the epicenter of Minneapolis, LPM Apartments is near the city’s most vibrant neighborhoods, including Downtown West, North Loop and Uptown. On-site, you can enjoy everything from Eggy's Diner to a get-together with friends at Bruhaven Brewery. Venture to the trendy North Loop area and catch a show at Acme Comedy Company or experience 360-degree views of downtown when you visit the Foshay Museum and Observation Deck.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents say LPM stands out for the views—and the details.</strong><br>Reviews highlight floor-to-ceiling windows, balconies, comfortable layouts, and a Central Minneapolis location close to daily essentials. Helpful staff, prompt maintenance, well-kept spaces, outdoor areas, fitness options, and work-friendly amenities also come up often. Read the reviews to see why one resident called the skyline views “beyond spectacular.”</p>",
  "property_neighborhood_blurb": "<p>Located at the epicenter of Minneapolis, LPM Apartments is near the city’s most vibrant neighborhoods, including Downtown West, North Loop and Uptown. On-site, you can enjoy everything from Eggy's Diner to a get-together with friends at Bruhaven Brewery. Venture to the trendy North Loop area and catch a show at Acme Comedy Company or experience 360-degree views of downtown when you visit the Foshay Museum and Observation Deck.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>LPM Apartments offers 40,000 square feet of community spaces to elevate your lifestyle. Steps outside your door is an indoor and outdoor pool, a state-of-the-art fitness center, and an outdoor event space. You’ll experience immediate comfort in your home with features like GE stainless steel appliances, floor-to-ceiling windows, and designer finishes.</p>",
  "property_applynow_blurb": "<p><strong>Start your next chapter at LPM Apartments.</strong><br>Set in Loring Park between North Loop and Uptown, LPM puts vibrant Minneapolis living within easy reach. Explore luxury apartments for rent, then begin your online application when you’re ready to make LPM home.</p>",
  "property_contactus_blurb": "<p>Fill out the form below, drop us a line, or stop by to learn how you can start living in luxury at LPM Apartments.</p>",
  "property_faqs_blurb": "<p><strong>Questions about life at LPM?</strong><br>Find quick answers about our Minneapolis luxury apartments, leasing details, community features, and what to expect when living in Loring Park between North Loop and Uptown. If you need anything else, the LPM leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits your downtown rhythm.</strong><br>LPM Apartments gives you a curated range of high-rise floor plans in Central Minneapolis, from open studios and one-bedroom homes to larger two- and three-bedroom residences and penthouse layouts with extra breathing room.</p><p>Inside, look for the details that make each plan feel polished and easy to use: floor-to-ceiling windows, open kitchens with stainless steel appliances and gas ranges, full-size washer/dryer sets, generous closets, and select glass-paneled balconies with city views. Compare available layouts, finishes, pricing, and move-in timing below, then explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorites in person.</p>",
  "property_gallery_blurb": "<p>You belong here! Picture yourself in LPM’s high-end apartments in the heart of downtown Minneapolis, MN. Notice each home’s elevated features, view the desirable amenities, and take in the community’s welcoming atmosphere.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore LPM from the map.</strong> See available apartments in Loring Park, then zoom out to discover how close you are to Downtown West, North Loop, Uptown, and the Minneapolis spots that make this address feel connected.</p>",
  "property_pets_blurb": "<p>At LPM Apartments, we’re not just pet-friendly, we LOVE pets and show it by providing a fenced-in pet exercise area, always having treats in the office and hosting frequent Yappy Hours…</p>",
  "property_referafriend_blurb": "<p><strong>Love life at LPM?</strong> Share the energy of Loring Park living—moments from Minneapolis’ vibrant neighborhoods, with luxury apartments and easy access to the city’s best. Invite a friend to discover LPM Apartments and join you here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at LPM Apartments</strong><br>Life at the epicenter of Minneapolis should stay effortless. Log in to pay rent, submit maintenance requests, and manage your account—so you can get back to enjoying LPM’s luxury apartment experience in Loring Park.</p>",
  "property_reviews_blurb": "<p><strong>See what residents are saying about LPM Apartments.</strong><br>As you read through the reviews, you’ll notice a few themes come up again and again: skyline views, responsive service, comfortable layouts, and a Central Minneapolis location that keeps daily life close at hand.</p><p>Residents frequently praise the floor-to-ceiling windows, balconies, helpful staff, and well-kept spaces, with one review summing it up simply: “The views are beyond spectacular.” You’ll also see appreciation for the <a href=\"/amenities\">amenities</a>, from relaxing outdoor areas to fitness and work-friendly spaces, along with maintenance teams that are described as prompt and professional.</p><p>Browse the reviews below to get a real feel for life at LPM—from move-in experiences to the everyday details residents value most.</p>",
  "property_created_at": "1752257052085",
  "property_scheduletour_blurb": "<p>Schedule your tour of LPM Apartments in downtown Minneapolis, MN, today! When you visit, you’ll be pleased to find studio, one, two, and three-bedroom apartments featuring wood plank flooring and a 27-foot balcony.</p><p>You’ll also love our community's media room and business center.</p><p>To see more of LPM Apartments, view a virtual tour by clicking the Virtual Tour button below. Or, use the calendar to schedule a live virtual tour or in-person tour, both guided by one of our knowledgeable leasing professionals. Touring restrictions may apply.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — we received your inquiry.</strong><br>The LPM leasing team will be in touch soon with more details. With a central Minneapolis location near Downtown West, North Loop, and Uptown, plus luxury apartments designed for connected city living, LPM makes it easy to feel at home.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through LPM before you arrive.</strong><br>Explore virtual tours that move beyond still photos, from community views to apartment walkthroughs in studio, one-bedroom, and two-bedroom layouts, plus the 3603 Penthouse and 11 Floorplan tours. As you click through, notice the high-rise perspective, open living areas, floor-to-ceiling windows, polished kitchens, in-home laundry, and select balcony moments that make each space easier to picture.</p><p>Use the tours to compare finishes, flow, and scale at your own pace, then keep exploring the <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready for a closer look in Central Minneapolis.</p>",
  "property_copyright": "2026 All Rights Reserved. LPM Apartments",
  "property_seo_title_home": "LPM Apartments |  Apartments in Minneapolis, MN",
  "property_seo_description_home": "Discover urban living at LPM Apartments, Minneapolis! Enjoy various floor plans, a rooftop terrace, fitness center, and concierge services. Find your home!",
  "property_seo_title_floorplans": "Floor Plans | Minneapolis, MN Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at LPM Apartments in Minneapolis! From cozy studios to spacious three-bedroom layouts, browse to uncover your perfect floor plan today!",
  "property_seo_title_amenities": "Amenities | Minneapolis, MN Apartments for Rent",
  "property_seo_description_amenities": "Experience unparalleled living at LPM Apartments! From stunning views and luxurious amenities to a vibrant community, your new home in Minneapolis awaits.",
  "property_seo_title_gallery": "Gallery | Apartments in Minneapolis, MN",
  "property_seo_description_gallery": "Discover vibrant living at LPM Apartments in Minneapolis! Enjoy stunning amenities, spacious layouts, and panoramic city views. Your new lifestyle awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | LPM Apartments Apartments",
  "property_seo_description_virtualtours": "Experience Minneapolis living at LPM Apartments! Take a virtual tour to see our stunning studio to three-bedroom layouts and find your perfect home today!",
  "property_seo_title_interactivemap": "Interactive Map | LPM Apartments Apartments",
  "property_seo_description_interactivemap": "Unlock your ideal living space at LPM Apartments in Minneapolis! Use our interactive map to find studio to three-bedroom homes with premium amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Minneapolis, MN",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhoods of Minneapolis near LPM Apartments. From cozy cafes to parks, explore local gems just steps from your new home.",
  "property_seo_title_contact": "Contact Us | LPM Apartments",
  "property_seo_description_contact": "Reach out to LPM Apartments in Minneapolis! From chic studios to spacious three-bedroom homes, our leasing team is ready to help you find your perfect fit.",
  "property_seo_title_faqs": "FAQs | Apartments in Minneapolis, MN",
  "property_seo_description_faqs": "Find answers to your burning questions about LPM Apartments in Minneapolis! Discover our unique amenities, floor plans, and community perks—all in one place!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Minneapolis, MN",
  "property_seo_description_reviews": "Discover vibrant living at LPM Apartments, Minneapolis! Explore resident reviews showcasing unique amenities, spacious layouts, and a welcoming community.",
  "property_seo_title_applynow": "Apply Now | Apartments in Minneapolis, MN",
  "property_seo_description_applynow": "Elevate your lifestyle at LPM Apartments in Minneapolis. Choose stylish studios to spacious three-bedrooms with great amenities. Apply online!",
  "property_seo_title_residentaccess": "Resident Access | LPM Apartments",
  "property_seo_description_residentaccess": "Manage your LPM Apartments experience in Minneapolis. Log in to the resident portal for rent payments, maintenance requests, and updates!",
  "property_seo_title_referafriend": "Refer A Friend | LPM Apartments",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to LPM Apartments in Minneapolis and share the joy of comfortable living in our vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | LPM Apartments",
  "property_seo_description_scheduletour": "Discover urban living at LPM Apartments in Minneapolis. Tour today and enjoy vibrant amenities in a welcoming community. Secure your spot!",
  "property_seo_title_privacy": "Privacy Policy | LPM Apartments",
  "property_seo_description_privacy": "At LPM Apartments in Minneapolis, your privacy matters. Review our comprehensive policy to learn how we protect your information. Click to read more!",
  "property_seo_title_accessibility": "Website Accessibility | LPM Apartments",
  "property_seo_description_accessibility": "At LPM Apartments in Minneapolis, we prioritize digital inclusion. Learn how our accessibility features empower everyone to enjoy our vibrant community.",
  "property_seo_title_sitemap": "Sitemap | LPM Apartments",
  "property_seo_description_sitemap": "Find your way to LPM Apartments in vibrant Minneapolis! Navigate our sitemap for a clear path to your dream home, amenities, and community details.",
  "property_seo_title_thankyou": "Thank You | LPM Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out to LPM Apartments in Minneapolis! Our team is excited to connect and help you find your perfect new home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Minneapolis, MN",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793650778110",
  "amenities": [
    {
      "id": "ec_a537b2d62ead7930f6c60360",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645038",
      "title": "Media and game rooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_79c56783b41288e4a45d77d5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645042",
      "title": "24-hour door staff and maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0de5303818f222200c63837d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645044",
      "title": "On-site professional management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_afeb6456437f01daab2fbc71",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645053",
      "title": "On-site parking garage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2163fc6113769a7c415a25f6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645060",
      "title": "State-of-the-art fitness center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_08923f2d37597ab07a7421a6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645062",
      "title": "Wireless internet: up to 500mbps",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_254b6084a9c74c82bcd65cf3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645064",
      "title": "Indoor pool and hot tub",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ad53d8031d9ad6fabdff274",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645077",
      "title": "Sauna and steam rooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_950544a314417f597c4f19bf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645082",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6525cf0939105ab6241b61f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645087",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4466a43d30c407ba4659f562",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645088",
      "title": "In-home laundry with full size washer and dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab5eee6d9375dee0e1e1af34",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645097",
      "title": "Spacious closets, including walk-ins",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f2329461066e56c0502369aa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645104",
      "title": "27 foot balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d587943498fe49a619cb289f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645107",
      "title": "Microwaves",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2e34d5635447d8497b8f1344",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645115",
      "title": "GE Clean Steel refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c5dc80d5f28d2c9202046fe2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645121",
      "title": "Panoramic City Views",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cce0c5699b08185f25b19558",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645122",
      "title": "Grey Stone Shaw or Fossil Shaw carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eecb337d89c44b138bdfa243",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645126",
      "title": "Gas range and electric oven",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_37d2b9fa0cca9ee9fbfed6b3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645133",
      "title": "Individually controlled heat and air-conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2db425a83d6c7c403a741932",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645039",
      "title": "Meeting/Study rooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6507c7c47a4552980d250224",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645090",
      "title": "Granite countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_afe31638bed2373da5ce18f4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645040",
      "title": "Green living LEED Silver Design",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d0077b38dce98d78844fac2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645094",
      "title": "Open floor plans with floor-to-ceiling windows",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3884c92d0ee1705f943abd99",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645041",
      "title": "Outdoor yoga/stretch area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f0e5cc33e1813a4240e68fd9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645043",
      "title": "Bicycle and resident storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2d566b5a258bcb93194a504a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645099",
      "title": "White cultured marble vanity top",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ba7ed6029c30aa6d826d23f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645101",
      "title": "Driftwood or Nutmeg plank flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_16294073a12ade67e8d8dc66",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645045",
      "title": "Landscaped deck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d9568946a9cbbf275e88a53f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645105",
      "title": "Brushed Aluminum Window Treatments",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_77714c1855641fcd38c6f065",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645106",
      "title": "Carmel wood kitchen cabinets with stainless steel pulls",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_898c3ad8aa70de90099b83a4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645047",
      "title": "Eggy`s Diner",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fc3ed3b06d1bc9703ca49492",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645049",
      "title": "Bicycle workshop",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6e8355dcae48b3f9532a842c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645050",
      "title": "Fire pits with lounge seating",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7cc79ad5e96c4d31db8c1a09",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645109",
      "title": "Two Finished Packages to choose from",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2653b9f4bcd2d21dde49cae7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645113",
      "title": "Kohler bath fixtures",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f292639a63fedaaf42c2f071",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645051",
      "title": "Outdoor yard Games",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b0d061f22392764c0335cf3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645052",
      "title": "Resident lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_db934b036bc699ea21bb79d3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645118",
      "title": "High-speed internet up to 500mbps and premium TV programming",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b165bd5e40bf24b16c26200d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645119",
      "title": "Arctic white subway tiles in bathroom",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_74f3a9de5c86626b0dfb5acc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645054",
      "title": "Luxer One Automated Package Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53992b9d73eb90e509e9c3e3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645120",
      "title": "GE Stainless Steel Energy Star appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4029467afdb3e18ffa26e4f4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645055",
      "title": "Indoor dog play room with lounge & dog wash",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ea94ae6d0bb38b8865492070",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645056",
      "title": "Package drop-off and pick-up including tracking and delivery notification",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a68e744d248d1f2ff29cb851",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645058",
      "title": "Guest Suite for family or friends",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_49df17d78a8ec3c75d374e8b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645129",
      "title": "Expansive glass paneled balconies",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2462e079ad67691a24707181",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645065",
      "title": "Outdoor pool and hot tub",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_876b80cc66454c73b0973c8a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645137",
      "title": "In-home laundry with full size washer and dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4863b29c0c1887f7ce014ae1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645066",
      "title": "Welcome Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e94729e81d0c6431e88fbf18",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645067",
      "title": "100 percent smoke-free environment",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_28c20ca72a796be0e65ec07e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645138",
      "title": "24 foot balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fad88fa7a350964a06294c7b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "126741817",
      "title": "Top Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_08f738a67b06a2caa5a14539",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "126741818",
      "title": "Floor Level 12 to 19",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8a4ec666f85d87184ccba23a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645068",
      "title": "Outdoor Event Space with Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d3c0aaf134c92c4f43d69910",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645069",
      "title": "Bru Haven Brewery",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c454b39e10ee70ee87f95628",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "126741819",
      "title": "Floor Level 7 to 11",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a77c599927ad2c06f19ed412",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "126741821",
      "title": "Floor Level 20 to 30",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7981d67d9d0622bf3af4329a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645070",
      "title": "Grilling stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d8711ce0f90682e5bd3178fc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "126741824",
      "title": "Floor Level 31 to 35",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_333dc45d6075c2c918f471dd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645071",
      "title": "Pool Cabanas and Lounging",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a1c6a3b31e2f9c23cfc2e087",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645072",
      "title": "Complimentary Resident Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_038597d4ed4dfdda6f918351",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "126741826",
      "title": "Wheelchair Accessible",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_207c011b2467057538d0f2bf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "120645079",
      "title": "Inspire: Global Gifts for Urban Adventurers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da029604a8d5e3fd588add5d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "123743040",
      "title": "Drycleaning Services Available*",
      "amount": "false",
      "description": "Through Mulberry's",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cfbd946f2b0e99e5e7b12886",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "128984173",
      "title": "Electric Vehicle Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_021d8ab667617ac5bc754bdb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d1f-93d2-716d-9c96-dbe798c45dcb.webp",
      "image_media": {
        "alt_text": "LPM Apartments reception desk with agate-inlaid front and property logo.",
        "public_id": "01a10d1f-93d2-716d-9c96-dbe798c45dcb",
        "storage_key": "property/6737460151191502/01a10d1f-93d2-716d-9c96-dbe798c45dcb.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Welcome to LPM Apartments! Our stylish reception area features a unique agate-inlaid desk and the LPM Apartments logo, creating a memorable first impression.",
      "link": "false",
      "alt_text": "The main reception desk and lobby area inside the LPM Apartments in Minneapolis.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(62).jpg"
    },
    {
      "id": "ec_55580b9590840190f3ebc4db",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d1f-b920-705a-9eb9-ad7acb503105.webp",
      "image_media": {
        "alt_text": "Modern lounge area with plush seating, decorative lighting, and a television mounted on a wood-paneled wall.",
        "public_id": "01a10d1f-b920-705a-9eb9-ad7acb503105",
        "storage_key": "property/6737460151191502/01a10d1f-b920-705a-9eb9-ad7acb503105.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating, ambient lighting, and entertainment options.",
      "link": "false",
      "alt_text": "The resident lounge and community room inside the LPM Apartments in Minneapolis.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(54).JPG"
    },
    {
      "id": "ec_49615f20e191b77607ecf4e1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d1f-c0d8-76db-b094-0ab3770b5bb0.webp",
      "image_media": {
        "alt_text": "Modern lobby lounge with seating area and coffee station",
        "public_id": "01a10d1f-c0d8-76db-b094-0ab3770b5bb0",
        "storage_key": "property/6737460151191502/01a10d1f-c0d8-76db-b094-0ab3770b5bb0.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Welcome guests or residents to a stylish lounge area featuring comfortable seating and a convenient coffee station.",
      "link": "false",
      "alt_text": "A modern bar area with a wooden counter and blue stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(52).jpg"
    },
    {
      "id": "ec_cf69f1e1ea1b66d217f4fc02",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d1f-b666-71eb-a5e8-83b437bc37a7.webp",
      "image_media": {
        "alt_text": "Modern apartment building lobby with seating areas and a communal kitchen.",
        "public_id": "01a10d1f-b666-71eb-a5e8-83b437bc37a7",
        "storage_key": "property/6737460151191502/01a10d1f-b666-71eb-a5e8-83b437bc37a7.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Welcome to the stylish lobby of our apartment community, featuring comfortable seating, a modern communal kitchen, and an inviting atmosphere for residents.",
      "link": "false",
      "alt_text": "A spacious and upscale main lobby and coffee bar lounge area inside the LPM Apartments in Minneapolis.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(59).jpg"
    },
    {
      "id": "ec_056fedcd55493c881b246aba",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d1f-bb71-7489-a199-fa345954599c.webp",
      "image_media": {
        "alt_text": "Business center with computers and seating",
        "public_id": "01a10d1f-bb71-7489-a199-fa345954599c",
        "storage_key": "property/6737460151191502/01a10d1f-bb71-7489-a199-fa345954599c.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Stay connected in our resident business center, featuring computers and comfortable seating.",
      "link": "false",
      "alt_text": "A modern resident business center or internet cafe station at the LPM Apartments in Minneapolis.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(53).jpg"
    },
    {
      "id": "ec_8c26a13741683da14be90600",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d1f-c437-7093-99f4-6f457f2e1279.webp",
      "image_media": {
        "alt_text": "Community lounge with sectional sofa, coffee tables, and a wet bar.",
        "public_id": "01a10d1f-c437-7093-99f4-6f457f2e1279",
        "storage_key": "property/6737460151191502/01a10d1f-c437-7093-99f4-6f457f2e1279.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Relax and unwind in our community lounge, featuring comfortable seating, coffee tables, and a convenient wet bar with a microwave and refrigerator.",
      "link": "false",
      "alt_text": "The resident lounge or media room at the LPM Apartments in Minneapolis.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(60).jpg"
    },
    {
      "id": "ec_6ffb552fd3a07b16ea07735d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d1f-e4dd-74ac-ba5e-134ff6a65460.webp",
      "image_media": {
        "alt_text": "Modern mailroom with a striking wood-paneled feature wall and rows of silver mailboxes.",
        "public_id": "01a10d1f-e4dd-74ac-ba5e-134ff6a65460",
        "storage_key": "property/6737460151191502/01a10d1f-e4dd-74ac-ba5e-134ff6a65460.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Check your mail in style in our sleek and modern mailroom, featuring a beautifully designed wood accent wall and convenient mailboxes.",
      "link": "false",
      "alt_text": "A wooden display case with drawers is in the foreground of a room with a grey wall and a black screen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(66).jpg"
    },
    {
      "id": "ec_37e5f2eb293477f07e3bcd01",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d1f-e879-73f5-a289-0de98d60ddbf.webp",
      "image_media": {
        "alt_text": "Spacious balcony with stunning city views and a clear blue sky with scattered clouds.",
        "public_id": "01a10d1f-e879-73f5-a289-0de98d60ddbf",
        "storage_key": "property/6737460151191502/01a10d1f-e879-73f5-a289-0de98d60ddbf.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Enjoy breathtaking city vistas from your private balcony. This expansive outdoor space offers a perfect retreat with a picturesque backdrop of the cityscape and lush greenery.",
      "link": "false",
      "alt_text": "A balcony with a metal railing overlooks a cityscape.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(63).jpg"
    },
    {
      "id": "ec_c7ec12efc65d9059b316ef0d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d1f-e47d-778b-978d-f61d0802548d.webp",
      "image_media": {
        "alt_text": "Round swimming pool with lounge chairs and umbrellas on a rooftop deck, with modern high-rise buildings in the background.",
        "public_id": "01a10d1f-e47d-778b-978d-f61d0802548d",
        "storage_key": "property/6737460151191502/01a10d1f-e47d-778b-978d-f61d0802548d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and umbrellas. Perfect for relaxing and soaking up the sun.",
      "link": "false",
      "alt_text": "A round pool with a 4'0\" height restriction sign.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(61).JPG"
    },
    {
      "id": "ec_ef3f055db0b99d406a33f651",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d20-1518-75ae-9177-de12e01f299d.webp",
      "image_media": {
        "alt_text": "Rooftop pool and hot tub area with lounge chairs and umbrellas, overlooking city skyline.",
        "public_id": "01a10d20-1518-75ae-9177-de12e01f299d",
        "storage_key": "property/6737460151191502/01a10d20-1518-75ae-9177-de12e01f299d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning rooftop pool or relax in the adjacent hot tub. Surrounded by comfortable lounge seating and vibrant greenery, this amenity offers the perfect urban oasis.",
      "link": "false",
      "alt_text": "A pool area with a hot tub and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(70).jpg"
    },
    {
      "id": "ec_4558dfc7ca60bbf181daba93",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d1f-ee02-7508-9801-b8003d2bfa0c.webp",
      "image_media": {
        "alt_text": "Outdoor cabanas with seating and tables on a patio, with a building in the background.",
        "public_id": "01a10d1f-ee02-7508-9801-b8003d2bfa0c",
        "storage_key": "property/6737460151191502/01a10d1f-ee02-7508-9801-b8003d2bfa0c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax in style under our outdoor cabanas, featuring comfortable seating and tables, perfect for enjoying the fresh air.",
      "link": "false",
      "alt_text": "Two luxury outdoor poolside or rooftop cabanas at the LPM Apartments in Minnesota.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(67).JPG"
    },
    {
      "id": "ec_05593cb6fa02d7aa0e044085",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d20-0e02-71a2-977c-9d40e2960f0f.webp",
      "image_media": {
        "alt_text": "Outdoor yoga mats laid out on a rooftop deck with city views and modern building.",
        "public_id": "01a10d20-0e02-71a2-977c-9d40e2960f0f",
        "storage_key": "property/6737460151191502/01a10d20-0e02-71a2-977c-9d40e2960f0f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor yoga sessions on our spacious rooftop deck, featuring panoramic city views and comfortable amenities for your wellness.",
      "link": "false",
      "alt_text": "An outdoor rooftop terrace at the LPM Apartments in Minnesota featuring a dedicated yoga or exercise space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(69).JPG"
    },
    {
      "id": "ec_441f868b1614edcca3c51c70",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d20-124d-761d-8373-fd20ab09e999.webp",
      "image_media": {
        "alt_text": "Rooftop patio area with outdoor bar, seating, and tables.",
        "public_id": "01a10d20-124d-761d-8373-fd20ab09e999",
        "storage_key": "property/6737460151191502/01a10d20-124d-761d-8373-fd20ab09e999.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy stunning city views from our rooftop patio, complete with an outdoor bar, comfortable seating, and dining areas for relaxation and entertainment.",
      "link": "false",
      "alt_text": "An outdoor rooftop lounge and bar area at the LPM Apartments in Minnesota.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(68).JPG"
    },
    {
      "id": "ec_853a7f74fb8e501a7d6b6847",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a5-f610-71bc-83e7-503ca0c238cd.webp",
      "image_media": {
        "alt_text": "Interior of a retail store with clothing, bags, and decorative items on display.",
        "public_id": "019d01a5-f610-71bc-83e7-503ca0c238cd",
        "storage_key": "property/6737460151191502/019d01a5-f610-71bc-83e7-503ca0c238cd.webp",
        "width": 1024,
        "height": 627
      },
      "title": "Other",
      "description": "Shop the latest styles in our boutique, featuring a curated collection of apparel, accessories, and home decor.",
      "link": "false",
      "alt_text": "An on-site retail boutique or gift shop interior within the LPM Apartments building in Minneapolis.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(74).jpg"
    },
    {
      "id": "ec_61bd14db7b612e310f7e5908",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d20-0775-70ea-b9fc-79817e2e1906.webp",
      "image_media": {
        "alt_text": "Modern open-concept living area and kitchen with white island, stainless steel appliances, and comfortable seating.",
        "public_id": "01a10d20-0775-70ea-b9fc-79817e2e1906",
        "storage_key": "property/6737460151191502/01a10d20-0775-70ea-b9fc-79817e2e1906.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Enjoy a spacious open-concept living area seamlessly connected to a modern kitchen. Featuring stainless steel appliances and a breakfast bar, perfect for entertaining.",
      "link": "false",
      "alt_text": "A modern, open-concept apartment living room and kitchen area at the LPM Apartments in Minnesota.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(65).jpg"
    },
    {
      "id": "ec_fdc5cc66ee38c73c46447484",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d20-1f13-779b-abec-e42457adcc68.webp",
      "image_media": {
        "alt_text": "Pool table and foosball table in a game room with city views.",
        "public_id": "01a10d20-1f13-779b-abec-e42457adcc68",
        "storage_key": "property/6737460151191502/01a10d20-1f13-779b-abec-e42457adcc68.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy the game room featuring a pool table and foosball table, perfect for friendly competition, with expansive windows offering scenic city views.",
      "link": "false",
      "alt_text": "A pool table in a room with a view of the city.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(64).jpg"
    },
    {
      "id": "ec_9e5650c123307bb5447dad33",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d20-200b-746d-92bb-b1ec7e1c3a07.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and island seating.",
        "public_id": "01a10d20-200b-746d-92bb-b1ec7e1c3a07",
        "storage_key": "property/6737460151191502/01a10d20-200b-746d-92bb-b1ec7e1c3a07.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring stainless steel appliances, granite countertops, and an island with bar stools. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "A modern kitchen with a dining table and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(58).jpg"
    },
    {
      "id": "ec_a8bbc667f24d6f1605368675",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d20-24ca-74c2-83cb-e9dab00c0f6b.webp",
      "image_media": {
        "alt_text": "Indoor dog park with agility equipment, benches, and tables.",
        "public_id": "01a10d20-24ca-74c2-83cb-e9dab00c0f6b",
        "storage_key": "property/6737460151191502/01a10d20-24ca-74c2-83cb-e9dab00c0f6b.webp",
        "width": 1024,
        "height": 637
      },
      "title": "Community",
      "description": "Enjoy our indoor dog park, a fun and safe space for your furry friends to play and socialize with agility equipment, comfortable seating, and convenient amenities.",
      "link": "false",
      "alt_text": "The indoor pet grooming and dog agility playroom station inside the LPM Apartments in Minneapolis.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(73).jpg"
    },
    {
      "id": "ec_e29e7f447e9f6613b1bd6c39",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d20-4800-7049-b2a8-6660343671e0.webp",
      "image_media": {
        "alt_text": "Rooftop hammocks with city skyline view",
        "public_id": "01a10d20-4800-7049-b2a8-6660343671e0",
        "storage_key": "property/6737460151191502/01a10d20-4800-7049-b2a8-6660343671e0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax in the hammocks on the rooftop, offering stunning views of the surrounding cityscape.",
      "link": "false",
      "alt_text": "An outdoor rooftop lawn and hammock lounge area at the LPM Apartments in Minneapolis.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(57).JPG"
    },
    {
      "id": "ec_64dffd740a9f6d6740b1ec2f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a6-09e7-7633-83b0-406a567f6777.webp",
      "image_media": {
        "alt_text": "Eggy's sign",
        "public_id": "019d01a6-09e7-7633-83b0-406a567f6777",
        "storage_key": "property/6737460151191502/019d01a6-09e7-7633-83b0-406a567f6777.webp",
        "width": 1207,
        "height": 768
      },
      "title": "Other",
      "description": "Illuminated sign that says Eggy's.",
      "link": "false",
      "alt_text": "A bright, red marquee sign spelling out \"EGGY'S\" inside the diner located at the LPM Apartments in Minneapolis.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(77).jpg"
    },
    {
      "id": "ec_136fcd5b1aa17a07644e2200",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a6-05d3-751d-b861-fb75febff647.webp",
      "image_media": {
        "alt_text": "Comfortable seating area with Adirondack chairs and tables on artificial turf with a brewery in the background.",
        "public_id": "019d01a6-05d3-751d-b861-fb75febff647",
        "storage_key": "property/6737460151191502/019d01a6-05d3-751d-b861-fb75febff647.webp",
        "width": 1024,
        "height": 682
      },
      "title": "Community",
      "description": "Relax and unwind in our unique community space, featuring comfortable Adirondack chairs and a lively atmosphere.",
      "link": "false",
      "alt_text": "An indoor lounge and social area modeled after an outdoor patio, located at the LPM Apartments in Minneapolis.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(75).jpg"
    },
    {
      "id": "ec_25653270e61dc1c90dea22fc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a5-ec37-75d0-b157-d7b36a2f146f.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, weight machines, and free weights",
        "public_id": "019d01a5-ec37-75d0-b157-d7b36a2f146f",
        "storage_key": "property/6737460151191502/019d01a5-ec37-75d0-b157-d7b36a2f146f.webp",
        "width": 1152,
        "height": 768
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with a wide variety of cardio and strength training equipment for residents.",
      "link": "false",
      "alt_text": "A gym with a variety of equipment including treadmills, weights, and benches.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(72).jpg"
    },
    {
      "id": "ec_0c1b2f23ae90e542020c233d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a5-d1b6-716e-bbf4-3a59db1f9c71.webp",
      "image_media": {
        "alt_text": "Bedroom with a large window and balcony access",
        "public_id": "019d01a5-d1b6-716e-bbf4-3a59db1f9c71",
        "storage_key": "property/6737460151191502/019d01a5-d1b6-716e-bbf4-3a59db1f9c71.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, modern nightstand, and a full-length mirror, with access to a private balcony offering city views.",
      "link": "false",
      "alt_text": "A bedroom with a bed, a nightstand, a chair, and a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(80).jpg"
    },
    {
      "id": "ec_096ede5154028d9191de1d5b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a5-9c06-730a-8a25-17a122bb6a65.webp",
      "image_media": {
        "alt_text": "Modern living room with large windows overlooking city skyline.",
        "public_id": "019d01a5-9c06-730a-8a25-17a122bb6a65",
        "storage_key": "property/6737460151191502/019d01a5-9c06-730a-8a25-17a122bb6a65.webp",
        "width": 1684,
        "height": 1123
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sofa, dining table, and expansive windows that showcase a breathtaking city view.",
      "link": "false",
      "alt_text": "A white couch with a red pillow is in the middle of a room with a cowhide rug.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(51).jpg"
    },
    {
      "id": "ec_2a9e5b6b4efe78ed9815b78b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a5-b110-73b9-83ea-38cd4c7fa96f.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with large windows and city views",
        "public_id": "019d01a5-b110-73b9-83ea-38cd4c7fa96f",
        "storage_key": "property/6737460151191502/019d01a5-b110-73b9-83ea-38cd4c7fa96f.webp",
        "width": 1675,
        "height": 1104
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this stylish apartment kitchen, complete with modern appliances and stunning panoramic city views through floor-to-ceiling windows.",
      "link": "false",
      "alt_text": "A modern kitchen with a view of the cityscape outside the large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(48).jpg"
    },
    {
      "id": "ec_ed345e67e75aa62c980f7aee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d20-32b9-757b-a2d5-b85a8558d554.webp",
      "image_media": {
        "alt_text": "Bedroom with king size bed and open closet.",
        "public_id": "01a10d20-32b9-757b-a2d5-b85a8558d554",
        "storage_key": "property/6737460151191502/01a10d20-32b9-757b-a2d5-b85a8558d554.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring a king-size bed, elegant nightstands, and ample closet space for convenient storage.",
      "link": "false",
      "alt_text": "A bedroom with a large bed and a small table with a vase on it.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(71).jpg"
    },
    {
      "id": "ec_759ea8a6231c3addeb7b2e4d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a5-ab10-75ee-adcd-13ff0c346b60.webp",
      "image_media": {
        "alt_text": "Living room with blue patterned sofa, two yellow chairs, blue armchair, and white coffee table.",
        "public_id": "019d01a5-ab10-75ee-adcd-13ff0c346b60",
        "storage_key": "property/6737460151191502/019d01a5-ab10-75ee-adcd-13ff0c346b60.webp",
        "width": 2000,
        "height": 1194
      },
      "title": "Apartment",
      "description": "Spacious living area with comfortable seating, including a decorative sofa and accent chairs, perfect for relaxing or entertaining guests.",
      "link": "false",
      "alt_text": "A brightly lit, modern apartment living room at the LPM Apartments in Minneapolis.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(50).jpg"
    },
    {
      "id": "ec_607752162a1a47b7d8014c1b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a5-cf37-74ea-982e-3aed9523439a.webp",
      "image_media": {
        "alt_text": "Modern bedroom with large windows and city view",
        "public_id": "019d01a5-cf37-74ea-982e-3aed9523439a",
        "storage_key": "property/6737460151191502/019d01a5-cf37-74ea-982e-3aed9523439a.webp",
        "width": 2000,
        "height": 1266
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed, contemporary art, and floor-to-ceiling windows with stunning city vistas.",
      "link": "false",
      "alt_text": "A bedroom with a large bed and a large window overlooking a cityscape.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(47).jpg"
    },
    {
      "id": "ec_d557a1daead78aadcf8dd557",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "title": "Apartment",
      "description": "Spacious and stylish living area featuring comfortable seating, a decorative bookshelf, and breathtaking panoramic city views from floor-to-ceiling windows.",
      "link": "false",
      "alt_text": "A living room with a grey couch, a coffee table, a bookshelf, and a large window with a view of the city.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(49).jpg"
    },
    {
      "id": "ec_0faf4d27ade7a7b368fb3a78",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d20-38df-726c-b9f0-7d9be2d3fa9c.webp",
      "image_media": {
        "alt_text": "Interior view of a modern apartment living room and kitchen area, featuring a sofa, shelves, and a kitchen counter.",
        "public_id": "01a10d20-38df-726c-b9f0-7d9be2d3fa9c",
        "storage_key": "property/6737460151191502/01a10d20-38df-726c-b9f0-7d9be2d3fa9c.webp",
        "width": 2000,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Step into this beautifully designed apartment living space, seamlessly integrated with a modern kitchen. Perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "A modern apartment living room and kitchen interior at the LPM Apartments in Minneapolis.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(46).jpg"
    },
    {
      "id": "ec_0b0c4830642d000c1079295a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d20-3aa9-72f8-9c19-d971a3172488.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower/tub.",
        "public_id": "01a10d20-3aa9-72f8-9c19-d971a3172488",
        "storage_key": "property/6737460151191502/01a10d20-3aa9-72f8-9c19-d971a3172488.webp",
        "width": 1728,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a spacious vanity with ample storage, a toilet, and a bathtub with a shower, all finished with contemporary fixtures and decor.",
      "link": "false",
      "alt_text": "A bathroom with a white tub, a white sink, a mirror, a shower curtain and a rug.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(79).jpg"
    },
    {
      "id": "ec_d30845fa2b5caedee4e89115",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a5-bd93-74da-ab58-e333cda0c846.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019d01a5-bd93-74da-ab58-e333cda0c846",
        "storage_key": "property/6737460151191502/019d01a5-bd93-74da-ab58-e333cda0c846.webp",
        "width": 2000,
        "height": 1373
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring a stainless steel refrigerator, microwave, and gas range, with granite countertops and ample cabinet space.",
      "link": "false",
      "alt_text": "A modern kitchen with a granite countertop and a bowl of fruit on it.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(78).jpg"
    },
    {
      "id": "ec_f0bcff9a307d8103c2685c64",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a5-ae20-7728-99f2-135d2c5e7e33.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and gray cabinetry.",
        "public_id": "019d01a5-ae20-7728-99f2-135d2c5e7e33",
        "storage_key": "property/6737460151191502/019d01a5-ae20-7728-99f2-135d2c5e7e33.webp",
        "width": 1923,
        "height": 1284
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, sleek gray cabinetry, and a large island with a double sink.",
      "link": "false",
      "alt_text": "A modern kitchen with a stainless steel refrigerator, a stove with an oven, and a sink with a faucet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(76).jpg"
    },
    {
      "id": "ec_644715724e36fa5469a30009",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d20-4b9f-75e2-992e-b12a1fa8672d.webp",
      "image_media": {
        "alt_text": "Empty apartment room with large windows and a city view.",
        "public_id": "01a10d20-4b9f-75e2-992e-b12a1fa8672d",
        "storage_key": "property/6737460151191502/01a10d20-4b9f-75e2-992e-b12a1fa8672d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience breathtaking city views from the expansive windows of your new apartment. This unfurnished space offers a blank canvas for you to create your dream home.",
      "link": "false",
      "alt_text": "A room with a large window overlooking a cityscape.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(55).jpg"
    },
    {
      "id": "ec_ef45a7cba9db7e481706e113",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a10d20-49ff-76e4-905f-e62ec1c776ab.webp",
      "image_media": {
        "alt_text": "Empty living room with panoramic city views through floor-to-ceiling windows.",
        "public_id": "01a10d20-49ff-76e4-905f-e62ec1c776ab",
        "storage_key": "property/6737460151191502/01a10d20-49ff-76e4-905f-e62ec1c776ab.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area with stunning city vistas, perfect for relaxing or entertaining. Enjoy natural light and a modern aesthetic.",
      "link": "false",
      "alt_text": "High-rise apartment living space at the LPM Apartments in Minneapolis featuring expansive floor-to-ceiling corner windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LPM-Apartments_Favorites%20(56).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_4b34901a-f16d-4ca1-bfc1-3f7eb56e4a3a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Café and Bar Lurcat",
      "poi_type": "Restaurants",
      "poi_address": "1624 Harmon Pl, Minneapolis, MN 55403, USA",
      "poi_short_description": "Bright & airy New American eatery presenting entrees & small plates of sophisticated comfort fare.",
      "poi_long_description": "Bright & airy New American eatery presenting entrees & small plates of sophisticated comfort fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-4bd0-76fb-ad04-94ea4726155c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-4bd0-76fb-ad04-94ea4726155c",
        "storage_key": "property/6737460151191502/01a03eb3-4bd0-76fb-ad04-94ea4726155c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.lurcatminneapolis.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7538664077555615705&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caf-and-bar-lurcat",
      "poi_latitude": "44.9712694",
      "poi_longitude": "-93.2862139",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 612-486-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba27-72eb-9136-d602546c9836.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba27-72eb-9136-d602546c9836",
        "storage_key": "property/6737460151191502/019d01a7-ba27-72eb-9136-d602546c9836.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9TrI_8Eys1IR2Uezdwm3nmg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_73d2750a-0731-4d57-9432-c8f3094ed241",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Cardamom - Closed",
      "poi_type": "Restaurants",
      "poi_address": "723 Vineland Pl, Minneapolis, MN 55403, USA",
      "poi_short_description": "Casual restaurant in the Walker Art Center offering Turkish-inspired plates and small plates, plus cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-3d11-76ea-9733-2b6cb0844b26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-3d11-76ea-9733-2b6cb0844b26",
        "storage_key": "property/6737460151191502/01a03eb3-3d11-76ea-9733-2b6cb0844b26.webp",
        "width": 1280,
        "height": 988
      },
      "poi_business_url": "http://www.cardamommpls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7333202375492156075&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cardamom---closed",
      "poi_latitude": "44.9685997",
      "poi_longitude": "-93.2891596",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 612-375-7542",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba27-72eb-9136-d602546c9836.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba27-72eb-9136-d602546c9836",
        "storage_key": "property/6737460151191502/019d01a7-ba27-72eb-9136-d602546c9836.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN2YtPiUzs1IRq7pCIbXExGU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d9856395-32d1-46b3-ba10-b61c40e0e93b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Gai Noi",
      "poi_type": "Restaurants",
      "poi_address": "1610 Harmon Pl, Minneapolis, MN 55403, USA",
      "poi_short_description": "Thai fixture featuring modern cuisine, family-style dining and a rooftop patio.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb0-780d-75c8-9f2f-c8d150be3579.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb0-780d-75c8-9f2f-c8d150be3579",
        "storage_key": "property/6737460151191502/01a03eb0-780d-75c8-9f2f-c8d150be3579.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.gainoimpls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8791079662501712614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gai-noi",
      "poi_latitude": "44.97159389999999",
      "poi_longitude": "-93.28545830000002",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba27-72eb-9136-d602546c9836.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba27-72eb-9136-d602546c9836",
        "storage_key": "property/6737460151191502/019d01a7-ba27-72eb-9136-d602546c9836.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwZlh67Uzs1IR5lKTO2AwAHo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d5f64d61-5169-4883-86ef-8f1d2b670ded",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "P.S. Steak",
      "poi_type": "Restaurants",
      "poi_address": "510 Groveland Ave, Minneapolis, MN 55403, USA",
      "poi_short_description": "A menu focused on steak & an array of classic & seasonal dishes & cocktails in an elevated setting.",
      "poi_long_description": "A menu focused on steak & an array of classic & seasonal dishes & cocktails in an elevated setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-37ff-7069-8b3e-fdee33ca7355.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-37ff-7069-8b3e-fdee33ca7355",
        "storage_key": "property/6737460151191502/01a03eb3-37ff-7069-8b3e-fdee33ca7355.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://www.psmpls.com/?utm_source=2060digital&utm_medium=localseo&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=13544086140995463877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ps-steak",
      "poi_latitude": "44.9672061",
      "poi_longitude": "-93.2873041",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 612-886-1620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba27-72eb-9136-d602546c9836.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba27-72eb-9136-d602546c9836",
        "storage_key": "property/6737460151191502/019d01a7-ba27-72eb-9136-d602546c9836.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjbG5mLszs1IRxWpT6ZVC9rs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_dd3aaaa0-db0b-49b0-b0cf-7db97622b35f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Sonora Mexican kitchen and bar",
      "poi_type": "Restaurants",
      "poi_address": "1414 Nicollet Ave, Minneapolis, MN 55403, USA",
      "poi_short_description": "Modern restaurant serving a menu of classic Mexican fare, from tacos to enchiladas, plus draft beers and margaritas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-3d0b-738f-8356-0e1c256fa922.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-3d0b-738f-8356-0e1c256fa922",
        "storage_key": "property/6737460151191502/01a03eb3-3d0b-738f-8356-0e1c256fa922.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sonoramexicankitchenandbar.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=8082608727255036637&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sonora-mexican-kitchen-and-bar",
      "poi_latitude": "44.96828230000001",
      "poi_longitude": "-93.2782233",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 612-351-4030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba27-72eb-9136-d602546c9836.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba27-72eb-9136-d602546c9836",
        "storage_key": "property/6737460151191502/019d01a7-ba27-72eb-9136-d602546c9836.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1Zwe71ozs1IR3TKCXtAxK3A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_47b2340e-f46a-4818-8d88-3b78feeb8110",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Zelo",
      "poi_type": "Restaurants",
      "poi_address": "831 Nicollet Mall, Minneapolis, MN 55402, USA",
      "poi_short_description": "Stylish destination for contemporary Italian dining with global influences, plus a lively bar scene.",
      "poi_long_description": "Stylish destination for contemporary Italian dining with global influences, plus a lively bar scene.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-3e25-71cc-ae98-5fc17708ce7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-3e25-71cc-ae98-5fc17708ce7c",
        "storage_key": "property/6737460151191502/01a03eb3-3e25-71cc-ae98-5fc17708ce7c.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://zelompls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=485509924627657902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zelo",
      "poi_latitude": "44.97504",
      "poi_longitude": "-93.2736207",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 612-333-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba27-72eb-9136-d602546c9836.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba27-72eb-9136-d602546c9836",
        "storage_key": "property/6737460151191502/019d01a7-ba27-72eb-9136-d602546c9836.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSRQF5JYys1IRrrRbQLTgvAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_2912f24a-c7ad-4771-bcc2-ade56bcb3e8a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "The Copper Hen Cakery & Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "2515 Nicollet Ave, Minneapolis, MN 55404, USA",
      "poi_short_description": "Farmhouse-chic restaurant & cake bakery offering market-to-table cooking, plus beer, wine & coffee.",
      "poi_long_description": "Farmhouse-chic restaurant & cake bakery offering market-to-table cooking, plus beer, wine & coffee.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-3857-7298-9e61-adc1759436b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-3857-7298-9e61-adc1759436b8",
        "storage_key": "property/6737460151191502/01a03eb3-3857-7298-9e61-adc1759436b8.webp",
        "width": 515,
        "height": 400
      },
      "poi_business_url": "http://www.copperhenkitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13662868509727465465&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-copper-hen-cakery--kitchen",
      "poi_latitude": "44.9566717",
      "poi_longitude": "-93.2777057",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 612-872-2221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba27-72eb-9136-d602546c9836.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba27-72eb-9136-d602546c9836",
        "storage_key": "property/6737460151191502/019d01a7-ba27-72eb-9136-d602546c9836.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJF9KF6rUys1IR-R8tR4VCnL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1aa1f4c2-c769-4a05-8d27-704dbbee903e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Quang Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2719 Nicollet Ave, Minneapolis, MN 55408, USA",
      "poi_short_description": "Vietnamese mainstay serving pho, banh mi, bubble tea, and more in a vibrant, no-frills setting.",
      "poi_long_description": "Vietnamese mainstay serving pho, banh mi, bubble tea, and more in a vibrant, no-frills setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-3b06-717d-b6d3-95a7d2e48476.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-3b06-717d-b6d3-95a7d2e48476",
        "storage_key": "property/6737460151191502/01a03eb3-3b06-717d-b6d3-95a7d2e48476.webp",
        "width": 1080,
        "height": 810
      },
      "poi_business_url": "http://www.quang-restaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3796495733282099030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quang-restaurant",
      "poi_latitude": "44.9530649",
      "poi_longitude": "-93.2776908",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 612-870-4739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba27-72eb-9136-d602546c9836.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba27-72eb-9136-d602546c9836",
        "storage_key": "property/6737460151191502/019d01a7-ba27-72eb-9136-d602546c9836.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLcnbWPUn9ocRVs-QNcHcrzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_b7ffe9da-4a8f-4379-a96f-32ed228f28fd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Icehouse",
      "poi_type": "Entertainment",
      "poi_address": "2528 Nicollet Ave, Minneapolis, MN 55404, USA",
      "poi_short_description": "Modern venue covering 2 floors with casual dining, specialty cocktails & live music.",
      "poi_long_description": "Modern venue covering 2 floors with casual dining, specialty cocktails & live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-3c52-74f6-b28a-a50b6358a22e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-3c52-74f6-b28a-a50b6358a22e",
        "storage_key": "property/6737460151191502/01a03eb3-3c52-74f6-b28a-a50b6358a22e.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.icehousempls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=556551660822278147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "icehouse",
      "poi_latitude": "44.9563206",
      "poi_longitude": "-93.278071",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 612-276-6523",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHy_yjrUys1IRAzB3aslEuQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_7f2d87e0-75d3-45ed-8225-ccdb7590c5ee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "The Nicollet Diner",
      "poi_type": "Restaurants",
      "poi_address": "1333 Nicollet Mall, Minneapolis, MN 55403, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-3863-773d-b60b-4bd3514531b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-3863-773d-b60b-4bd3514531b8",
        "storage_key": "property/6737460151191502/01a03eb3-3863-773d-b60b-4bd3514531b8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thenicolletdiner.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9961679854469849717&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-nicollet-diner",
      "poi_latitude": "44.9702005",
      "poi_longitude": "-93.2776395",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 612-399-6258",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-89d1-7498-9d46-7f6bdf581c16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03eb3-89d1-7498-9d46-7f6bdf581c16",
        "storage_key": "property/6737460151191502/01a03eb3-89d1-7498-9d46-7f6bdf581c16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpfy5Fv0zs1IRdSLXYwz_Poo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cocktail_bar"
    },
    {
      "id": "custom_0ae4d860-61f6-43a0-8771-0507bf92affa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Muffin Top Cafè",
      "poi_type": "Restaurants",
      "poi_address": "1424 Nicollet Ave, Minneapolis, MN 55403, USA",
      "poi_short_description": "Low-key, gay-friendly coffeehouse providing espresso drinks, house-baked pastries & savory snacks.",
      "poi_long_description": "Low-key, gay-friendly coffeehouse providing espresso drinks, house-baked pastries & savory snacks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-3c9d-72ae-affe-31498a4b9241.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-3c9d-72ae-affe-31498a4b9241",
        "storage_key": "property/6737460151191502/01a03eb3-3c9d-72ae-affe-31498a4b9241.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://muffintopcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5557638048263569197&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "muffin-top-caf",
      "poi_latitude": "44.9679723",
      "poi_longitude": "-93.278081",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 612-326-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-89df-73f5-91f2-1970ca678065.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03eb3-89df-73f5-91f2-1970ca678065",
        "storage_key": "property/6737460151191502/01a03eb3-89df-73f5-91f2-1970ca678065.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ4TBVIb8ys1IRLf_x-FuyIE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_cc2ad576-0715-4d76-aa55-5b3b0fc47f12",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Eli's Food & Cocktails",
      "poi_type": "Restaurants",
      "poi_address": "1225 Hennepin Ave, Minneapolis, MN 55403, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-3fae-72e0-8cf1-ec66b9275df1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-3fae-72e0-8cf1-ec66b9275df1",
        "storage_key": "property/6737460151191502/01a03eb3-3fae-72e0-8cf1-ec66b9275df1.webp",
        "width": 667,
        "height": 445
      },
      "poi_business_url": "http://elisfoodandcocktails.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18400833615849488257&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elis-food--cocktails",
      "poi_latitude": "44.97423329999999",
      "poi_longitude": "-93.2813417",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 612-332-9997",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba27-72eb-9136-d602546c9836.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba27-72eb-9136-d602546c9836",
        "storage_key": "property/6737460151191502/019d01a7-ba27-72eb-9136-d602546c9836.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLdMuKesys1IRgX_Gi67kXP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_8fa22fbb-e596-47ee-ad07-424cafa92abc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Centro",
      "poi_type": "Restaurants",
      "poi_address": "2412 Nicollet Ave, Minneapolis, MN 55404, USA",
      "poi_short_description": "Counter-serve spot offering draft beer and cocktails along with tacos and burgers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-4278-7679-b1a5-64fc7cd82804.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-4278-7679-b1a5-64fc7cd82804",
        "storage_key": "property/6737460151191502/01a03eb3-4278-7679-b1a5-64fc7cd82804.webp",
        "width": 1280,
        "height": 692
      },
      "poi_business_url": "http://centrompls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2567623017265303775&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centro",
      "poi_latitude": "44.9585644",
      "poi_longitude": "-93.2782374",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 612-452-9785",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba27-72eb-9136-d602546c9836.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba27-72eb-9136-d602546c9836",
        "storage_key": "property/6737460151191502/019d01a7-ba27-72eb-9136-d602546c9836.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvwnhmjYzs1IR3xA3xYcHoiM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_f2f02e95-98e2-4e6f-a4b2-c25bc65238e9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Pimento Jamaican Kitchen & Rum Bar",
      "poi_type": "Restaurants",
      "poi_address": "2524 Nicollet Ave, Minneapolis, MN 55404, USA",
      "poi_short_description": "Colorful counter serve featuring traditional Jamaican cuisine such as jerk chicken & braised oxtail.",
      "poi_long_description": "Colorful counter serve featuring traditional Jamaican cuisine such as jerk chicken & braised oxtail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-4091-76f4-a975-e9e2be0a1b4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-4091-76f4-a975-e9e2be0a1b4f",
        "storage_key": "property/6737460151191502/01a03eb3-4091-76f4-a975-e9e2be0a1b4f.webp",
        "width": 920,
        "height": 614
      },
      "poi_business_url": "http://www.pimento.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15242113159227526797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pimento-jamaican-kitchen--rum-bar",
      "poi_latitude": "44.9564277",
      "poi_longitude": "-93.2781079",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 612-345-5637",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba27-72eb-9136-d602546c9836.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba27-72eb-9136-d602546c9836",
        "storage_key": "property/6737460151191502/019d01a7-ba27-72eb-9136-d602546c9836.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw_AZpgozs1IRjU4QgindhtM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a417ead5-3885-4be8-ad13-2a7251f5b744",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Mother Clucker's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "1428 Nicollet Ave, Minneapolis, MN 55403, USA",
      "poi_short_description": "Casual restaurant featuring gourmet pizzas and fried chicken along with beer and wine.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-4292-763a-ae85-7bee15920c1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-4292-763a-ae85-7bee15920c1b",
        "storage_key": "property/6737460151191502/01a03eb3-4292-763a-ae85-7bee15920c1b.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.mothercluckerspizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=654754084256310378&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mother-cluckers-pizza",
      "poi_latitude": "44.9678575",
      "poi_longitude": "-93.2780644",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 612-699-4647",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba27-72eb-9136-d602546c9836.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba27-72eb-9136-d602546c9836",
        "storage_key": "property/6737460151191502/019d01a7-ba27-72eb-9136-d602546c9836.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcQCjkczs1IRamRV314nFgk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_3d25cc4d-494f-4633-a703-5acaa8b87434",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Oak Grove Grocery",
      "poi_type": "Shopping & Retail",
      "poi_address": "218 Oak Grove St, Minneapolis, MN 55403, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-45a8-709c-9932-7e881263de58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-45a8-709c-9932-7e881263de58",
        "storage_key": "property/6737460151191502/01a03eb3-45a8-709c-9932-7e881263de58.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.instagram.com/oakgrovegrocery/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3965334339379752663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-grove-grocery",
      "poi_latitude": "44.9666808",
      "poi_longitude": "-93.281902",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 612-871-1137",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba2a-754f-aed1-89cd1781d388.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba2a-754f-aed1-89cd1781d388",
        "storage_key": "property/6737460151191502/019d01a7-ba2a-754f-aed1-89cd1781d388.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-5JVMscys1IR125jipKyBzc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5f64127d-72ec-4685-bd24-178c2425bd69",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "AM Food Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1814 Nicollet Ave, Minneapolis, MN 55403, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-6025-70cf-8db3-e54a2cbada97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-6025-70cf-8db3-e54a2cbada97",
        "storage_key": "property/6737460151191502/01a03eb3-6025-70cf-8db3-e54a2cbada97.webp",
        "width": 1165,
        "height": 1280
      },
      "poi_business_url": "http://www.amfoodsmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2959329766416940090&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "am-food-market",
      "poi_latitude": "44.9649068",
      "poi_longitude": "-93.2782489",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 612-872-4805",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba2a-754f-aed1-89cd1781d388.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba2a-754f-aed1-89cd1781d388",
        "storage_key": "property/6737460151191502/019d01a7-ba2a-754f-aed1-89cd1781d388.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUbdfWrgys1IROnyFTL6mESk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_39c9e493-d4c6-412f-b129-e2721f9134b5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Net Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "1845 Nicollet Ave, Minneapolis, MN 55403, USA",
      "poi_short_description": "Grocery store for quick visits that some say is easygoing.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-4ab2-7715-ba58-3f524f0d4c98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-4ab2-7715-ba58-3f524f0d4c98",
        "storage_key": "property/6737460151191502/01a03eb3-4ab2-7715-ba58-3f524f0d4c98.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11371967333452749267&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "net-supermarket",
      "poi_latitude": "44.9640895",
      "poi_longitude": "-93.2775508",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 612-870-3820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba2a-754f-aed1-89cd1781d388.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba2a-754f-aed1-89cd1781d388",
        "storage_key": "property/6737460151191502/019d01a7-ba2a-754f-aed1-89cd1781d388.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ22chTrgys1IR0xnM2wlY0Z0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_3947af24-514a-48ea-830c-0de3aab66e55",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Mighty Spark",
      "poi_type": "Shopping & Retail",
      "poi_address": "1625 Hennepin Ave #100, Minneapolis, MN 55403, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-4aaa-75de-b6e8-8d642c4b39c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-4aaa-75de-b6e8-8d642c4b39c3",
        "storage_key": "property/6737460151191502/01a03eb3-4aaa-75de-b6e8-8d642c4b39c3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://mightysparkfood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15616593882327372094&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mighty-spark",
      "poi_latitude": "44.9719955",
      "poi_longitude": "-93.28614",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 888-333-1735",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba25-7568-982c-47f0f116a7ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba25-7568-982c-47f0f116a7ba",
        "storage_key": "property/6737460151191502/019d01a7-ba25-7568-982c-47f0f116a7ba.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAWBQVaUzs1IRPlGpTWVJudg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "food_store"
    },
    {
      "id": "custom_1ed49025-40b9-40c1-bff1-8c0e8b655452",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Lunds & Byerlys Downtown Minneapolis",
      "poi_type": "Shopping & Retail",
      "poi_address": "1201 Hennepin Ave, Minneapolis, MN 55403, USA",
      "poi_short_description": "Downtown grocery chain with a Caribou coffee bar, deli and sushi, plus a hot bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-49a0-71ad-9577-ee219a25029c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-49a0-71ad-9577-ee219a25029c",
        "storage_key": "property/6737460151191502/01a03eb3-49a0-71ad-9577-ee219a25029c.webp",
        "width": 800,
        "height": 534
      },
      "poi_business_url": "https://lundsandbyerlys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17958765823051151674&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lunds--byerlys-downtown-minneapolis",
      "poi_latitude": "44.9743631",
      "poi_longitude": "-93.2808535",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 612-379-5040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba2a-754f-aed1-89cd1781d388.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba2a-754f-aed1-89cd1781d388",
        "storage_key": "property/6737460151191502/019d01a7-ba2a-754f-aed1-89cd1781d388.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYWdK0JQys1IROrljz11aOvk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_27be6592-b458-4355-989a-a49f8abc15c7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "222 Hennepin Ave, Minneapolis, MN 55401, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb0-7235-779b-945e-b726e2efdbb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb0-7235-779b-945e-b726e2efdbb8",
        "storage_key": "property/6737460151191502/01a03eb0-7235-779b-945e-b726e2efdbb8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/hennepin?utm_source=google&utm_medium=organic&utm_campaign=listings&ref_=US_TRF_ALL_UFG_WFM_FRSOC_1001509",
      "poi_directions_map_url": "https://maps.google.com/?cid=1570021031660216664&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "44.98273289999999",
      "poi_longitude": "-93.2693518",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 612-313-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba2a-754f-aed1-89cd1781d388.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba2a-754f-aed1-89cd1781d388",
        "storage_key": "property/6737460151191502/019d01a7-ba2a-754f-aed1-89cd1781d388.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTKP34Qys1IRWOH_Wc_VyRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_2da70b8a-8c7d-453a-949c-24e842c0988a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "900 Nicollet Mall, Minneapolis, MN 55403, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-4e2a-72c8-a77b-c0bf4172bebd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-4e2a-72c8-a77b-c0bf4172bebd",
        "storage_key": "property/6737460151191502/01a03eb3-4e2a-72c8-a77b-c0bf4172bebd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/mpls-nicollet-mall/1375",
      "poi_directions_map_url": "https://maps.google.com/?cid=17670872680649818414&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "44.974929",
      "poi_longitude": "-93.274424",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 612-338-0085",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba25-7568-982c-47f0f116a7ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba25-7568-982c-47f0f116a7ba",
        "storage_key": "property/6737460151191502/019d01a7-ba25-7568-982c-47f0f116a7ba.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJFY3e2ZUys1IRLoFJKRSNO_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_3e8fb682-5581-4229-8f86-b17d9943fda2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "1010 W Lake St, Minneapolis, MN 55408, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-4dd6-7113-bc88-cd84aaa44f77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-4dd6-7113-bc88-cd84aaa44f77",
        "storage_key": "property/6737460151191502/01a03eb3-4dd6-7113-bc88-cd84aaa44f77.webp",
        "width": 1280,
        "height": 1032
      },
      "poi_business_url": "https://www.cvs.com/store-locator/minneapolis-mn-pharmacies/1010-lake-west-lake-st-minneapolis-mn-55408/storeid=8285?WT.mc_id=LS_GOOGLE_FS_8285",
      "poi_directions_map_url": "https://maps.google.com/?cid=8061386693970198692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "44.9488055",
      "poi_longitude": "-93.2927128",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 612-822-1297",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXVQpuoYn9ocRpIAns3zM328",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_b53db535-cd40-46cd-b091-dc4df15dd3dd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Kowalski's Markets",
      "poi_type": "Shopping & Retail",
      "poi_address": "2440 Hennepin Ave, Minneapolis, MN 55405, USA",
      "poi_short_description": "Supermarket chain stocking a range of everyday & gourmet items, with a focus on local producers.",
      "poi_long_description": "Supermarket chain stocking a range of everyday & gourmet items, with a focus on local producers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-4dd5-71c8-a55d-bcd5faded1e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-4dd5-71c8-a55d-bcd5faded1e6",
        "storage_key": "property/6737460151191502/01a03eb3-4dd5-71c8-a55d-bcd5faded1e6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.kowalskis.com/location/uptown-market-wine-shop?utm_source=google%20my%20business&utm_medium=organic&utm_campaign=Uptown%20Market%20GMB%20Listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1649490599667712125&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kowalskis-markets",
      "poi_latitude": "44.9578285",
      "poi_longitude": "-93.2960858",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 612-377-3448",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba2a-754f-aed1-89cd1781d388.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba2a-754f-aed1-89cd1781d388",
        "storage_key": "property/6737460151191502/019d01a7-ba2a-754f-aed1-89cd1781d388.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa_rXhNYys1IRfUCKBfYq5BY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_cc48023f-db7d-49c1-bdb9-78e00bbee537",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Third Avenue Food Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "1905 3rd Ave S, Minneapolis, MN 55404, USA",
      "poi_short_description": "Corner store with a small tobacco shop offering fresh produce and a selection of canned drinks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-515b-724d-9e28-2f90367df408.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-515b-724d-9e28-2f90367df408",
        "storage_key": "property/6737460151191502/01a03eb3-515b-724d-9e28-2f90367df408.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/Third-avenue-food-supermarket-1338944149556128",
      "poi_directions_map_url": "https://maps.google.com/?cid=13329907624072996200&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "third-avenue-food-supermarket",
      "poi_latitude": "44.96379599999999",
      "poi_longitude": "-93.2726465",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 612-871-7425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba2a-754f-aed1-89cd1781d388.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba2a-754f-aed1-89cd1781d388",
        "storage_key": "property/6737460151191502/019d01a7-ba2a-754f-aed1-89cd1781d388.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT8BhXboys1IRaGWk9VtY_bg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a9758a8b-6f6f-4caf-98f8-72d525c65959",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Emerson Dual Language School",
      "poi_type": "Education",
      "poi_address": "1421 Spruce Pl, Minneapolis, MN 55403, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-4f4b-71e8-841b-3f7f52ebc4fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-4f4b-71e8-841b-3f7f52ebc4fb",
        "storage_key": "property/6737460151191502/01a03eb3-4f4b-71e8-841b-3f7f52ebc4fb.webp",
        "width": 1080,
        "height": 720
      },
      "poi_business_url": "https://emerson.mpschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13909493475737570271&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emerson-dual-language-school",
      "poi_latitude": "44.9682529",
      "poi_longitude": "-93.2804462",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 612-668-3610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba66-770b-bd71-f12e94f457d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba66-770b-bd71-f12e94f457d0",
        "storage_key": "property/6737460151191502/019d01a7-ba66-770b-bd71-f12e94f457d0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoeQ3mMAys1IR34vz2p5yCME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_2962d91e-6a15-4041-a821-b75c4102a5cb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Child Garden Montessori School",
      "poi_type": "Education",
      "poi_address": "1601 Laurel Ave W, Minneapolis, MN 55403, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-50e8-7549-8a60-4f7224502a39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-50e8-7549-8a60-4f7224502a39",
        "storage_key": "property/6737460151191502/01a03eb3-50e8-7549-8a60-4f7224502a39.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "https://childgardenmontessori.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11446849882047827738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "child-garden-montessori-school",
      "poi_latitude": "44.9737619",
      "poi_longitude": "-93.2861297",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 612-377-1698",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba66-770b-bd71-f12e94f457d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba66-770b-bd71-f12e94f457d0",
        "storage_key": "property/6737460151191502/019d01a7-ba66-770b-bd71-f12e94f457d0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCewkrdwys1IRGs-u2FFh254",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_681bca9d-b6d1-495d-9d65-ee841cecdafc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Minneapolis College",
      "poi_type": "Education",
      "poi_address": "1501 Hennepin Ave, Minneapolis, MN 55403, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb0-8e45-725c-b307-4e7ca7874fd7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb0-8e45-725c-b307-4e7ca7874fd7",
        "storage_key": "property/6737460151191502/01a03eb0-8e45-725c-b307-4e7ca7874fd7.webp",
        "width": 1280,
        "height": 895
      },
      "poi_business_url": "http://www.minneapolis.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18306040378800738842&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minneapolis-college",
      "poi_latitude": "44.9728923",
      "poi_longitude": "-93.2832714",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 612-659-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba66-770b-bd71-f12e94f457d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba66-770b-bd71-f12e94f457d0",
        "storage_key": "property/6737460151191502/019d01a7-ba66-770b-bd71-f12e94f457d0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnWP8Zuoys1IRGhJgJrweDP4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_240bab62-97d5-4771-85bb-c42522e2f7d2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "FAIR School for Arts",
      "poi_type": "Education",
      "poi_address": "10 S 10th St, Minneapolis, MN 55403, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-52a3-7241-80bf-7d96e21543c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-52a3-7241-80bf-7d96e21543c5",
        "storage_key": "property/6737460151191502/01a03eb3-52a3-7241-80bf-7d96e21543c5.webp",
        "width": 1280,
        "height": 914
      },
      "poi_business_url": "http://fair.mpls.k12.mn.us/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=10563128528789911269&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fair-school-for-arts",
      "poi_latitude": "44.9757723",
      "poi_longitude": "-93.2775773",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 612-668-1060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba66-770b-bd71-f12e94f457d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba66-770b-bd71-f12e94f457d0",
        "storage_key": "property/6737460151191502/019d01a7-ba66-770b-bd71-f12e94f457d0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEW7-P5Qys1IR5TZRW27Fl5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_3988f558-14c3-43fd-acf4-244ca134cd85",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Loring Nicollet Alternative School",
      "poi_type": "Education",
      "poi_address": "20 S 13th St, Minneapolis, MN 55403, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-536f-73a5-9249-3fe709ee34f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-536f-73a5-9249-3fe709ee34f3",
        "storage_key": "property/6737460151191502/01a03eb3-536f-73a5-9249-3fe709ee34f3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.ppl-inc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18212231868547168841&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "loring-nicollet-alternative-school",
      "poi_latitude": "44.9730936",
      "poi_longitude": "-93.2806181",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 612-872-3626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba66-770b-bd71-f12e94f457d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba66-770b-bd71-f12e94f457d0",
        "storage_key": "property/6737460151191502/019d01a7-ba66-770b-bd71-f12e94f457d0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKWghMLgys1IRSXrNU2TYvvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_428175a1-b56b-4c8f-b77c-4815c63b5c2a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "MNIC High School - Downtown Campus",
      "poi_type": "Education",
      "poi_address": "511 Groveland Ave, Minneapolis, MN 55403, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://mnic.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8393869350559586944&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mnic-high-school---downtown-campus",
      "poi_latitude": "44.9662987",
      "poi_longitude": "-93.2876416",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 612-588-1449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba66-770b-bd71-f12e94f457d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba66-770b-bd71-f12e94f457d0",
        "storage_key": "property/6737460151191502/019d01a7-ba66-770b-bd71-f12e94f457d0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKXPZ54Ezs1IRgJoko7MDfXQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_755f98bb-148a-42f2-9e13-40e2320bf071",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Walker Art Center",
      "poi_type": "Entertainment",
      "poi_address": "725 Vineland Pl, Minneapolis, MN 55403, USA",
      "poi_short_description": "Acclaimed venue featuring contemporary art in a variety of media, plus a sculpture garden & bistro.",
      "poi_long_description": "Acclaimed venue featuring contemporary art in a variety of media, plus a sculpture garden & bistro.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-53fc-7298-beea-eb62f910155f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-53fc-7298-beea-eb62f910155f",
        "storage_key": "property/6737460151191502/01a03eb3-53fc-7298-beea-eb62f910155f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://walkerart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13983112962245836178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walker-art-center",
      "poi_latitude": "44.9681442",
      "poi_longitude": "-93.2886494",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 612-375-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkXzI4m4rs1IRkr3SSCf_DcI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4ec14af0-0d39-414d-84ec-b38111871361",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "MacPhail Center For Music",
      "poi_type": "Education",
      "poi_address": "501 S 2nd St, Minneapolis, MN 55401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-546c-72f5-a6f8-d457569430a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-546c-72f5-a6f8-d457569430a7",
        "storage_key": "property/6737460151191502/01a03eb3-546c-72f5-a6f8-d457569430a7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.macphail.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8591874561945551312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macphail-center-for-music",
      "poi_latitude": "44.9795417",
      "poi_longitude": "-93.2604868",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 612-321-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba66-770b-bd71-f12e94f457d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba66-770b-bd71-f12e94f457d0",
        "storage_key": "property/6737460151191502/019d01a7-ba66-770b-bd71-f12e94f457d0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMX63j2Its1IR0MF6c2R4PHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_eba33357-a0e7-441a-b85c-3fb2df144894",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Children's Theatre Company",
      "poi_type": "Entertainment",
      "poi_address": "2400 3rd Ave S, Minneapolis, MN 55404, USA",
      "poi_short_description": "Local troupe known for adapting children's classics into stage productions for the whole family.",
      "poi_long_description": "Local troupe known for adapting children's classics into stage productions for the whole family.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-54e9-7159-875e-c9ca4ec9b928.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-54e9-7159-875e-c9ca4ec9b928",
        "storage_key": "property/6737460151191502/01a03eb3-54e9-7159-875e-c9ca4ec9b928.webp",
        "width": 1280,
        "height": 896
      },
      "poi_business_url": "https://childrenstheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10663298056224339578&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-theatre-company",
      "poi_latitude": "44.9581382",
      "poi_longitude": "-93.2733517",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 612-874-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT0k6WbEys1IRenZd5xWl-5M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_291ce7a2-76a3-4c91-adf5-56cf59e1e914",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Minneapolis College of Art and Design",
      "poi_type": "Education",
      "poi_address": "2501 Stevens Ave, Minneapolis, MN 55404, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-56d5-73ab-81cf-7598af7ef8d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-56d5-73ab-81cf-7598af7ef8d2",
        "storage_key": "property/6737460151191502/01a03eb3-56d5-73ab-81cf-7598af7ef8d2.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://mcad.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15215479062634328060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minneapolis-college-of-art-and-design",
      "poi_latitude": "44.957213",
      "poi_longitude": "-93.2748314",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 612-874-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba66-770b-bd71-f12e94f457d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba66-770b-bd71-f12e94f457d0",
        "storage_key": "property/6737460151191502/019d01a7-ba66-770b-bd71-f12e94f457d0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDSb7ErQys1IR_G-2p5c9KNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_96936586-281b-40c8-b569-f52788713ae3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Spoonbridge and Cherry",
      "poi_type": "Entertainment",
      "poi_address": "14357 Loring Greenway, Minneapolis, MN 55403, USA",
      "poi_short_description": "Outdoor sculpture park with free admission and walking paths, plus nearby parking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-574b-77e9-8c92-95922f6b6493.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-574b-77e9-8c92-95922f6b6493",
        "storage_key": "property/6737460151191502/01a03eb3-574b-77e9-8c92-95922f6b6493.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://walkerart.org/collections/artworks/spoonbridge-and-cherry",
      "poi_directions_map_url": "https://maps.google.com/?cid=6205344874279166244&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spoonbridge-and-cherry",
      "poi_latitude": "44.9702348",
      "poi_longitude": "-93.2890588",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 612-375-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuYKi7cIys1IRJGEzLEnQHVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sculpture"
    },
    {
      "id": "custom_3a74afd7-2ec3-400b-9275-6494c6d2a8a6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "First Avenue",
      "poi_type": "Entertainment",
      "poi_address": "701 N 1st Ave, Minneapolis, MN 55403, USA",
      "poi_short_description": "Housed in an old depot, this rock venue & tiny side bar have hosted & launched many acts since 1970.",
      "poi_long_description": "Housed in an old depot, this rock venue & tiny side bar have hosted & launched many acts since 1970.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-565a-7383-8f86-895c21f81ea4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-565a-7383-8f86-895c21f81ea4",
        "storage_key": "property/6737460151191502/01a03eb3-565a-7383-8f86-895c21f81ea4.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://first-avenue.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12518072061981438790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-avenue",
      "poi_latitude": "44.9785315",
      "poi_longitude": "-93.2759978",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 612-338-8388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP6i4fJEys1IRRjMlfzcgua0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_4f3dad3c-b776-450b-b4e4-24853d97836b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Orpheum Theatre",
      "poi_type": "Entertainment",
      "poi_address": "910 Hennepin Ave, Minneapolis, MN 55403, USA",
      "poi_short_description": "Opened in 1921, this restored, 2,579-seat theater offers Broadway musicals, concerts & other events.",
      "poi_long_description": "Opened in 1921, this restored, 2,579-seat theater offers Broadway musicals, concerts & other events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-584b-76c2-b0f2-9e09c41e5b4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-584b-76c2-b0f2-9e09c41e5b4a",
        "storage_key": "property/6737460151191502/01a03eb3-584b-76c2-b0f2-9e09c41e5b4a.webp",
        "width": 1200,
        "height": 946
      },
      "poi_business_url": "https://hennepinarts.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3974691316620455144&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orpheum-theatre",
      "poi_latitude": "44.9763025",
      "poi_longitude": "-93.2774629",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 612-339-7007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL-FGVpEys1IR6Oz9krHwKDc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_ae8c5434-599a-468f-ac80-0c7bb1fbc7fd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Dakota",
      "poi_type": "Entertainment",
      "poi_address": "1010 Nicollet Mall, Minneapolis, MN 55403, USA",
      "poi_short_description": "Intimate cabaret venue with live music every night, plus a full-service American restaurant & bar.",
      "poi_long_description": "Intimate cabaret venue with live music every night, plus a full-service American restaurant & bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-5a47-72ba-8bee-2132a729f7fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-5a47-72ba-8bee-2132a729f7fa",
        "storage_key": "property/6737460151191502/01a03eb3-5a47-72ba-8bee-2132a729f7fa.webp",
        "width": 942,
        "height": 629
      },
      "poi_business_url": "https://www.dakotacooks.com/?utm_source=Google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=5680837229094929133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dakota",
      "poi_latitude": "44.9736976",
      "poi_longitude": "-93.2753807",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 612-332-5299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJccvNZpYys1IR7YIEi1xj1k4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_a2459136-59bf-4124-8c22-d63572e5175d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Guthrie Theater",
      "poi_type": "Entertainment",
      "poi_address": "818 S 2nd St, Minneapolis, MN 55415, USA",
      "poi_short_description": "Landmark venue for wide-ranging plays on 3 stages, full-service dining, several bars & river views.",
      "poi_long_description": "Landmark venue for wide-ranging plays on 3 stages, full-service dining, several bars & river views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-5949-7378-8f3f-43a13ac6bdb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-5949-7378-8f3f-43a13ac6bdb5",
        "storage_key": "property/6737460151191502/01a03eb3-5949-7378-8f3f-43a13ac6bdb5.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.guthrietheater.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14415037625030132595&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "guthrie-theater",
      "poi_latitude": "44.9781701",
      "poi_longitude": "-93.2558665",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 612-377-2224",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dxNCmQts1IRc8PPh1iADMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_2c75c9bb-0cbd-430d-a3e5-2bf275c42383",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Minnesota Orchestra",
      "poi_type": "Entertainment",
      "poi_address": "1111 Nicollet Mall, Minneapolis, MN 55403, USA",
      "poi_short_description": "Cube-filled auditorium, known for its acoustics, hosting diverse concerts for grown-ups & kids.",
      "poi_long_description": "Cube-filled auditorium, known for its acoustics, hosting diverse concerts for grown-ups & kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-5c98-76b9-87ad-210f495eafa4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-5c98-76b9-87ad-210f495eafa4",
        "storage_key": "property/6737460151191502/01a03eb3-5c98-76b9-87ad-210f495eafa4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.minnesotaorchestra.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15846864621971788818&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minnesota-orchestra",
      "poi_latitude": "44.972579",
      "poi_longitude": "-93.27508480000002",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 612-371-5656",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgW6GHJYys1IRElRV1Glf69s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_17fa2038-16a7-4fd6-9102-e1cbd29728dc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Target Field",
      "poi_type": "Entertainment",
      "poi_address": "1 Twins Way, Minneapolis, MN 55403, USA",
      "poi_short_description": "Home baseball stadium for the Minnesota Twins offering group & private behind-the-scenes tours.",
      "poi_long_description": "Home baseball stadium for the Minnesota Twins offering group & private behind-the-scenes tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb0-9f1f-7618-9e54-3e4dea3a4e65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb0-9f1f-7618-9e54-3e4dea3a4e65",
        "storage_key": "property/6737460151191502/01a03eb0-9f1f-7618-9e54-3e4dea3a4e65.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mlb.com/twins/ballpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=16492843063147742549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target-field",
      "poi_latitude": "44.9817241",
      "poi_longitude": "-93.2774749",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 612-659-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be36-7292-824b-bd3f39066b66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be36-7292-824b-bd3f39066b66",
        "storage_key": "property/6737460151191502/019d01a7-be36-7292-824b-bd3f39066b66.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJYc87o0ys1IRVcUvE2JZ4uQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_8fda2e31-e3d6-4d14-9bdc-0ff028609045",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Target Center",
      "poi_type": "Entertainment",
      "poi_address": "600 N 1st Ave, Minneapolis, MN 55403, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-5cb5-77f8-bb64-2e46ba3439d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-5cb5-77f8-bb64-2e46ba3439d2",
        "storage_key": "property/6737460151191502/01a03eb3-5cb5-77f8-bb64-2e46ba3439d2.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.targetcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15590685453279924204&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target-center",
      "poi_latitude": "44.9794633",
      "poi_longitude": "-93.2760947",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 612-673-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe1j2u5Eys1IR7I-ZF9E9Xdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_5cb7b3b8-4e18-443f-9c32-63ae36b98257",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Bryant Lake Bowl and Theater",
      "poi_type": "Entertainment",
      "poi_address": "810 W Lake St, Minneapolis, MN 55408, USA",
      "poi_short_description": "Funky alley & bar hosts DJs plus music & theater performers while serving a simple American menu.",
      "poi_long_description": "Funky alley & bar hosts DJs plus music & theater performers while serving a simple American menu.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-607c-74e9-a676-06ffa5a53dc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-607c-74e9-a676-06ffa5a53dc2",
        "storage_key": "property/6737460151191502/01a03eb3-607c-74e9-a676-06ffa5a53dc2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bryantlakebowl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5389449810521333560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bryant-lake-bowl-and-theater",
      "poi_latitude": "44.9485233",
      "poi_longitude": "-93.2901423",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 612-825-3737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqRmGeoYn9ocROJ_rUgwsy0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_0845bf09-b762-4943-815f-842c756c9ca7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Hennepin Healthcare",
      "poi_type": "Health and Wellness",
      "poi_address": "701 Park Ave, Minneapolis, MN 55404, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-5d83-7350-9f0e-b3eac591f70b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-5d83-7350-9f0e-b3eac591f70b",
        "storage_key": "property/6737460151191502/01a03eb3-5d83-7350-9f0e-b3eac591f70b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5364710283124104956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hennepin-healthcare",
      "poi_latitude": "44.9724191",
      "poi_longitude": "-93.2620715",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 612-873-3180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-bea3-7416-b7cf-56b209ce7593.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-bea3-7416-b7cf-56b209ce7593",
        "storage_key": "property/6737460151191502/019d01a7-bea3-7416-b7cf-56b209ce7593.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJoaIY2Zkys1IR_F5_PJRHc0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_ac80d32e-27ae-407b-83c4-d221ff085272",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Allina Health Urgent Care – Greenway (Minneapolis)",
      "poi_type": "Health and Wellness",
      "poi_address": "3270 W Lake St Ste 3264, Minneapolis, MN 55416, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-6080-7670-abea-6a2a610bb9c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-6080-7670-abea-6a2a610bb9c2",
        "storage_key": "property/6737460151191502/01a03eb3-6080-7670-abea-6a2a610bb9c2.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "https://account.allinahealth.org/locations/1880?utm_source=gmb&utm_medium=organic&utm_content=web-url&utm_campaign=gmb_website&utm_term=Allina-Health-Urgent-Care-Greenway",
      "poi_directions_map_url": "https://maps.google.com/?cid=1828202768561725610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allina-health-urgent-care--greenway-minneapolis",
      "poi_latitude": "44.9489481",
      "poi_longitude": "-93.3218358",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 612-262-8890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnwxIj3In9ocRquCBVbsUXxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_67f2f73c-9ed5-4593-9189-a2db76f77e4c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Allina Health Uptown Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "Uptown Row Building, 1221 W Lake St #201, Minneapolis, MN 55408, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-6091-751a-bfcc-bb52d9953d10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-6091-751a-bfcc-bb52d9953d10",
        "storage_key": "property/6737460151191502/01a03eb3-6091-751a-bfcc-bb52d9953d10.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "https://account.allinahealth.org/locations/89?utm_source=gmb&utm_medium=organic&utm_content=web-url&utm_campaign=gmb_website&utm_term=Allina-Health-Uptown-Clinic",
      "poi_directions_map_url": "https://maps.google.com/?cid=3743871771243951475&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allina-health-uptown-clinic",
      "poi_latitude": "44.9481512",
      "poi_longitude": "-93.2947167",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 612-824-1772",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPzOlXYEn9ocRc7WbQYrn9DM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_8c872b22-9d48-45a2-a7e8-d7f9fd34f769",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Walgreens Specialty Pharmacy at Allina Med Clinic/Uptown Row",
      "poi_type": "Health and Wellness",
      "poi_address": "1221 W Lake St #200, Minneapolis, MN 55408, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-60f4-7548-a28a-2d0810b83a7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-60f4-7548-a28a-2d0810b83a7a",
        "storage_key": "property/6737460151191502/01a03eb3-60f4-7548-a28a-2d0810b83a7a.webp",
        "width": 750,
        "height": 421
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1221+w+lake+st-minneapolis-mn-55408/id=11916",
      "poi_directions_map_url": "https://maps.google.com/?cid=16425413238751874991&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-specialty-pharmacy-at-allina-med-clinicuptown-row",
      "poi_latitude": "44.9481666",
      "poi_longitude": "-93.2947895",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 612-824-1036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-89cd-72cb-9569-49bb854b20db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03eb3-89cd-72cb-9569-49bb854b20db",
        "storage_key": "property/6737460151191502/01a03eb3-89cd-72cb-9569-49bb854b20db.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPzOlXYEn9ocRr8_NqFDK8uM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_20169f20-8769-4b32-8978-abcf48c09c40",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1010 W Lake St, Minneapolis, MN 55408, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-621a-744d-af05-e7f8f09445eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-621a-744d-af05-e7f8f09445eb",
        "storage_key": "property/6737460151191502/01a03eb3-621a-744d-af05-e7f8f09445eb.webp",
        "width": 720,
        "height": 481
      },
      "poi_business_url": "https://www.cvs.com/store-locator/minneapolis-mn-pharmacies/1010-west-lake-st-minneapolis-mn-55408/storeid=8285?WT.mc_id=LS_GOOGLE_RX_8285",
      "poi_directions_map_url": "https://maps.google.com/?cid=1628980255437438053&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "44.9488055",
      "poi_longitude": "-93.2927128",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 612-822-1297",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-89cd-72cb-9569-49bb854b20db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03eb3-89cd-72cb-9569-49bb854b20db",
        "storage_key": "property/6737460151191502/01a03eb3-89cd-72cb-9569-49bb854b20db.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr6Llu4Yn9ocRZTx5X-lMmxY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_89f91ea6-c9e3-4d9e-9c2e-0585a40f0c7e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3001 Hennepin Ave Ste 2210, Minneapolis, MN 55408, USA",
      "poi_short_description": "Big chain fitness center offering classes, personal training and equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-6671-77fc-a719-b7224c6e1a3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-6671-77fc-a719-b7224c6e1a3a",
        "storage_key": "property/6737460151191502/01a03eb3-6671-77fc-a719-b7224c6e1a3a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=582&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=2557567826498125856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "44.947895",
      "poi_longitude": "-93.2973937",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 612-392-0395",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp9M7-oEn9ocRIIBjO2NOfiM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_212fbd75-96e2-4ac6-a3aa-00ed32e2ae14",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Club Pilates Minneapolis Lakes",
      "poi_type": "Health and Wellness",
      "poi_address": "3200B W Lake St, Minneapolis, MN 55416, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-67ae-75db-967c-1f563de84287.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-67ae-75db-967c-1f563de84287",
        "storage_key": "property/6737460151191502/01a03eb3-67ae-75db-967c-1f563de84287.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.clubpilates.com/minneapolislakes/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=6556159508829062008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates-minneapolis-lakes",
      "poi_latitude": "44.94882870000001",
      "poi_longitude": "-93.3198485",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 612-564-0677",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba66-770b-bd71-f12e94f457d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba66-770b-bd71-f12e94f457d0",
        "storage_key": "property/6737460151191502/019d01a7-ba66-770b-bd71-f12e94f457d0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL-2qXLMn9ocReEOOVlYo_Fo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5d7df28c-369d-4a42-b0e5-630f1bf89e42",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "CYCLEBAR",
      "poi_type": "Health and Wellness",
      "poi_address": "2927 Girard Ave S, Minneapolis, MN 55408, USA",
      "poi_short_description": "Intense rides and energizing music in a clean studio with welcoming staff, plus rentals.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-6530-716b-a4bc-b01ba75016dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-6530-716b-a4bc-b01ba75016dc",
        "storage_key": "property/6737460151191502/01a03eb3-6530-716b-a4bc-b01ba75016dc.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://cyclebar.com/location/uptown-minneapolis",
      "poi_directions_map_url": "https://maps.google.com/?cid=13253461365779128477&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cyclebar",
      "poi_latitude": "44.9489835",
      "poi_longitude": "-93.2969981",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 612-353-4492",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJezTAl4En9ocRneCgb-TA7bc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5ee2c7bb-4ae0-4fd7-b312-75704df9be19",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Blaisdell YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "3335 Blaisdell Ave, Minneapolis, MN 55408, USA",
      "poi_short_description": "Gym with a swimming pool, an indoor track and a sauna.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb0-a3d8-75e2-95ce-c8be214e208e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb0-a3d8-75e2-95ce-c8be214e208e",
        "storage_key": "property/6737460151191502/01a03eb0-a3d8-75e2-95ce-c8be214e208e.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.ymcanorth.org/locations/blaisdell_ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=13804925343073064778&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blaisdell-ymca",
      "poi_latitude": "44.9421175",
      "poi_longitude": "-93.2793183",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 612-827-5401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK05BwZIn9ocRSleoOHXylL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_95f1166c-fe2d-414e-b7c2-8ec87f3a37e6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "CorePower Yoga - Downtown Minneapolis",
      "poi_type": "Health and Wellness",
      "poi_address": "501 Washington Ave S Suite 200, Minneapolis, MN 55415, USA",
      "poi_short_description": "Chain yoga studio offering a variety of physically intense workout classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-66cf-703a-9d01-a25696df2b04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-66cf-703a-9d01-a25696df2b04",
        "storage_key": "property/6737460151191502/01a03eb3-66cf-703a-9d01-a25696df2b04.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.corepoweryoga.com/yoga-studios/mn/twin-cities/downtown-minneapolis",
      "poi_directions_map_url": "https://maps.google.com/?cid=10861629432621417724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corepower-yoga---downtown-minneapolis",
      "poi_latitude": "44.978525",
      "poi_longitude": "-93.261007",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 833-448-2561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba66-770b-bd71-f12e94f457d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba66-770b-bd71-f12e94f457d0",
        "storage_key": "property/6737460151191502/019d01a7-ba66-770b-bd71-f12e94f457d0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZbarh50ys1IR_MRT7WtCvJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_c6868e0c-9a98-4be2-bae0-972bb75b2b93",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Loring Community Arts Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1382 Willow St, Minneapolis, MN 55403, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-6666-755c-af01-e9acc1f2eee6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-6666-755c-af01-e9acc1f2eee6",
        "storage_key": "property/6737460151191502/01a03eb3-6666-755c-af01-e9acc1f2eee6.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18022135619651873937&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "loring-community-arts-center",
      "poi_latitude": "44.968943",
      "poi_longitude": "-93.2829036",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 612-370-4929",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD9Dx88Ays1IRkaxDV9x8G_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_6d0ca663-cfe0-4f10-b8ea-cc39a8f796c6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Loring Greenway",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1234 La Salle Ave, Minneapolis, MN 55403, USA",
      "poi_short_description": "This functional city pedestrian path offers water features, public art, trees & a playground.",
      "poi_long_description": "This functional city pedestrian path offers water features, public art, trees & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-6ca7-733e-9600-4b0b26ba4ab1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-6ca7-733e-9600-4b0b26ba4ab1",
        "storage_key": "property/6737460151191502/01a03eb3-6ca7-733e-9600-4b0b26ba4ab1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.loringgreenway.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17408308681947477287&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "loring-greenway",
      "poi_latitude": "44.9710356",
      "poi_longitude": "-93.2798305",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-c171-769d-8137-87610b72a2c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-c171-769d-8137-87610b72a2c4",
        "storage_key": "property/6737460151191502/019d01a7-c171-769d-8137-87610b72a2c4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb2qd778ys1IRJ_XTV4O8lvE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_938e4f36-44ea-4d0b-a6fb-e21124bd452b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Peavey Plaza",
      "poi_type": "Entertainment",
      "poi_address": "1101 Nicollet Mall, Minneapolis, MN 55403, USA",
      "poi_short_description": "Parklike plaza featuring fountains and waterfalls, plus a spot where visitors can walk through water.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-6780-7599-a044-2aa3d595139e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-6780-7599-a044-2aa3d595139e",
        "storage_key": "property/6737460151191502/01a03eb3-6780-7599-a044-2aa3d595139e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://peaveyplaza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10506159838705562811&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peavey-plaza",
      "poi_latitude": "44.9722696",
      "poi_longitude": "-93.2756329",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1cRj9r0ys1IRuzSFk7VgzZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "plaza"
    },
    {
      "id": "custom_a0d32732-86cd-4c36-990f-62ee02ca02af",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Mill Ruins Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "102 Portland Ave S, Minneapolis, MN 55401, USA",
      "poi_short_description": "City park built around a historic old mill, featuring interpretive signs, walking & biking paths.",
      "poi_long_description": "City park built around a historic old mill, featuring interpretive signs, walking & biking paths.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-6ab9-70ff-87bc-016ebff80811.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-6ab9-70ff-87bc-016ebff80811",
        "storage_key": "property/6737460151191502/01a03eb3-6ab9-70ff-87bc-016ebff80811.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.minneapolisparks.org/parks__destinations/parks__lakes/mill_ruins_park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3203557236263153407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mill-ruins-park",
      "poi_latitude": "44.9798041",
      "poi_longitude": "-93.2563898",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 612-313-7793",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-c171-769d-8137-87610b72a2c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-c171-769d-8137-87610b72a2c4",
        "storage_key": "property/6737460151191502/019d01a7-c171-769d-8137-87610b72a2c4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxVSAem8ts1IR_-4YTVVSdSw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9582ab1d-a483-41ed-a135-75a0f662572b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Historic Stone Arch Bridge",
      "poi_type": "Entertainment",
      "poi_address": "100 Portland Ave, Minneapolis, MN 55401, USA",
      "poi_short_description": "Biking & walking paths on this former railroad bridge with panoramic views of St. Anthony Falls.",
      "poi_long_description": "Biking & walking paths on this former railroad bridge with panoramic views of St. Anthony Falls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-6dd4-766e-a1c2-49561d07aa24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-6dd4-766e-a1c2-49561d07aa24",
        "storage_key": "property/6737460151191502/01a03eb3-6dd4-766e-a1c2-49561d07aa24.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.minneapolisparks.org/parks__destinations/historical_sites/stone_arch_bridge/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16373684327107019915&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "historic-stone-arch-bridge",
      "poi_latitude": "44.9807491",
      "poi_longitude": "-93.2536972",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 612-230-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-89e1-76ea-bf3a-1db76df8018b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03eb3-89e1-76ea-bf3a-1db76df8018b",
        "storage_key": "property/6737460151191502/01a03eb3-89e1-76ea-bf3a-1db76df8018b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf2ekX5wys1IRi0SY3SQDO-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_2e3336d4-d350-4976-9da7-7e6b93984f8f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Water Works Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "425 W River Pkwy, Minneapolis, MN 55401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-6f6d-742c-86a3-d107162eb0d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-6f6d-742c-86a3-d107162eb0d1",
        "storage_key": "property/6737460151191502/01a03eb3-6f6d-742c-86a3-d107162eb0d1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.minneapolisparks.org/parks-destinations/parks-lakes/water-works-at-mill-ruins-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2771664839041664637&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "water-works-park",
      "poi_latitude": "44.98118849999999",
      "poi_longitude": "-93.2601941",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-c171-769d-8137-87610b72a2c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-c171-769d-8137-87610b72a2c4",
        "storage_key": "property/6737460151191502/019d01a7-c171-769d-8137-87610b72a2c4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz7rAb6Mts1IRfcaEd3zudiY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e88f5e59-51bd-4580-b758-7eb7e01b9097",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Father Hennepin Bluff Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "420 SE Main St, Minneapolis, MN 55414, USA",
      "poi_short_description": "Natural 8-acre riverside park named after a Franciscan priest with trails, bridges & city views.",
      "poi_long_description": "Natural 8-acre riverside park named after a Franciscan priest with trails, bridges & city views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-7422-744c-8477-8d25648862eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-7422-744c-8477-8d25648862eb",
        "storage_key": "property/6737460151191502/01a03eb3-7422-744c-8477-8d25648862eb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.minneapolisparks.org/parks__destinations/parks__lakes/father_hennepin_bluff_park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17698487560587572914&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "father-hennepin-bluff-park",
      "poi_latitude": "44.9826286",
      "poi_longitude": "-93.2526985",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 612-230-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-c171-769d-8137-87610b72a2c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-c171-769d-8137-87610b72a2c4",
        "storage_key": "property/6737460151191502/019d01a7-c171-769d-8137-87610b72a2c4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJd6p4n3ots1IRsvZ9bqqonfU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b18e10f0-b8c0-42d7-baeb-0cb1b8d28d7a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Nicollet Island Pavilion",
      "poi_type": "Entertainment",
      "poi_address": "40 Power Street, Minneapolis, MN 55401, USA",
      "poi_short_description": "Relaxed venue for weddings, riverfront events and corporate galas, featuring downtown views and picnic spots.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-7a5e-723d-afaa-16357ea4f480.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-7a5e-723d-afaa-16357ea4f480",
        "storage_key": "property/6737460151191502/01a03eb3-7a5e-723d-afaa-16357ea4f480.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.mintahoe.com/venues/nicollet-island-pavilion/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7511159251213763455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nicollet-island-pavilion",
      "poi_latitude": "44.9847379",
      "poi_longitude": "-93.2601096",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 612-253-0255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJheSJxn0ts1IRf0P8C4v_PGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_3ff64895-0dc2-4c6a-a866-4c69ebfed935",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Gold Medal Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Second Street and 11th Avenue South, Minneapolis, MN 55415, USA",
      "poi_short_description": "This 7.5-acre landscaped park features a unique mound with a spiral walkway & water views.",
      "poi_long_description": "This 7.5-acre landscaped park features a unique mound with a spiral walkway & water views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-73b0-76af-8af1-be159d4043be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-73b0-76af-8af1-be159d4043be",
        "storage_key": "property/6737460151191502/01a03eb3-73b0-76af-8af1-be159d4043be.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.goldmedalpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1851636197876332634&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gold-medal-park",
      "poi_latitude": "44.9776218",
      "poi_longitude": "-93.2532512",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 612-904-5607",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-c171-769d-8137-87610b72a2c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-c171-769d-8137-87610b72a2c4",
        "storage_key": "property/6737460151191502/019d01a7-c171-769d-8137-87610b72a2c4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJtaby02Uts1IRWnisw09Vshk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6d6ff79a-7dc1-4fb6-9a23-26353725717c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "LPM Apartments",
      "poi_type": "Transportation & Transit",
      "poi_address": "1369 Spruce Pl, Minneapolis, MN 55403, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-746f-73fa-8f84-3ab4fa74e7cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-746f-73fa-8f84-3ab4fa74e7cf",
        "storage_key": "property/6737460151191502/01a03eb3-746f-73fa-8f84-3ab4fa74e7cf.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.lpmapartments.com/?rcstdid=Mg%3D%3D-YRjTEizZPgM%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16159329513397333411&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lpm-apartments",
      "poi_latitude": "44.969124",
      "poi_longitude": "-93.2807057",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 612-445-4688",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcw9lfMAys1IRo62InpN4QeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "apartment_complex"
    },
    {
      "id": "custom_42ecf40f-e3c1-4f98-b894-7107bec6d1a6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Warehouse District/Hennepin Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Minneapolis, MN 55401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb0-d42b-735b-9428-f9550c2b6c0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb0-d42b-735b-9428-f9550c2b6c0b",
        "storage_key": "property/6737460151191502/01a03eb0-d42b-735b-9428-f9550c2b6c0b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10497940574180118857&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "warehouse-districthennepin-ave",
      "poi_latitude": "44.9800346",
      "poi_longitude": "-93.2730954",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb0-fc9e-736c-8e41-3c964b5b7b82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03eb0-fc9e-736c-8e41-3c964b5b7b82",
        "storage_key": "property/6737460151191502/01a03eb0-fc9e-736c-8e41-3c964b5b7b82.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJlw7mOJAys1IRSZEq7VQtsJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_01b5d305-8dbc-4ad8-a25e-aa376228213c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Nicollet Mall",
      "poi_type": "Transportation & Transit",
      "poi_address": "Minneapolis, MN 55401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb0-ef2e-70d9-aa9c-61a35168cf90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb0-ef2e-70d9-aa9c-61a35168cf90",
        "storage_key": "property/6737460151191502/01a03eb0-ef2e-70d9-aa9c-61a35168cf90.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16088033710719254394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nicollet-mall",
      "poi_latitude": "44.9785783",
      "poi_longitude": "-93.2699344",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb0-fc9e-736c-8e41-3c964b5b7b82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03eb0-fc9e-736c-8e41-3c964b5b7b82",
        "storage_key": "property/6737460151191502/01a03eb0-fc9e-736c-8e41-3c964b5b7b82.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJL2AFXZoys1IRej_u_WstRN8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_76e22881-5285-4577-b3e7-6acfd7300d1b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Government Plaza",
      "poi_type": "Transportation & Transit",
      "poi_address": "Minneapolis, MN 55487, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-b0f8-755f-a86e-a6ac46c0edf6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-b0f8-755f-a86e-a6ac46c0edf6",
        "storage_key": "property/6737460151191502/019d01a7-b0f8-755f-a86e-a6ac46c0edf6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1944303954529763037&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "government-plaza",
      "poi_latitude": "44.9768693",
      "poi_longitude": "-93.26616",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb0-fc9e-736c-8e41-3c964b5b7b82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03eb0-fc9e-736c-8e41-3c964b5b7b82",
        "storage_key": "property/6737460151191502/01a03eb0-fc9e-736c-8e41-3c964b5b7b82.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJtWlIAJwys1IR3T4iMSWO-xo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_ce3e22c0-51ae-4cba-8984-207f001daf95",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Target Field Station Plaza & Amphitheater",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "501-531 N 5th Ave, Minneapolis, MN 55401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-765f-7519-a13d-db816cc50a79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-765f-7519-a13d-db816cc50a79",
        "storage_key": "property/6737460151191502/01a03eb3-765f-7519-a13d-db816cc50a79.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mlb.com/twins/ballpark/target-field-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=1818962880312293877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target-field-station-plaza--amphitheater",
      "poi_latitude": "44.9830962",
      "poi_longitude": "-93.2786481",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 612-659-3870",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-c171-769d-8137-87610b72a2c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-c171-769d-8137-87610b72a2c4",
        "storage_key": "property/6737460151191502/019d01a7-c171-769d-8137-87610b72a2c4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJibw33L0zs1IR9bmiNBpBPhk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1dc75eb9-bb7c-40c8-816e-1b8c0d3c81a6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Greyhound: Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "516 2nd Ave N, Minneapolis, MN 55403, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-76cb-7055-a74b-bad1835c87a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-76cb-7055-a74b-bad1835c87a5",
        "storage_key": "property/6737460151191502/01a03eb3-76cb-7055-a74b-bad1835c87a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.greyhound.com/bus/minneapolis-mn/minneapolis-bus-station?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=14577147766726156729&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-station",
      "poi_latitude": "44.9807626",
      "poi_longitude": "-93.2757798",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpbhomJMys1IRuWEXKqluTMo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_40fc740b-115f-485d-8ac7-b88e1a368bb6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Minneapolis-Saint Paul International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "4300 Glumack Dr, St Paul, MN 55111, USA",
      "poi_short_description": "International hub with direct light rail service to Downtown Minneapolis & the Mall of America.",
      "poi_long_description": "International hub with direct light rail service to Downtown Minneapolis & the Mall of America.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-768e-70f9-ab64-0a31ab4e7464.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-768e-70f9-ab64-0a31ab4e7464",
        "storage_key": "property/6737460151191502/01a03eb3-768e-70f9-ab64-0a31ab4e7464.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.mspairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3158100295267399057&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minneapolis-saint-paul-international-airport",
      "poi_latitude": "44.8850593",
      "poi_longitude": "-93.2144354",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 50 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 612-726-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-89f3-7537-a071-43170e135c28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03eb3-89f3-7537-a071-43170e135c28",
        "storage_key": "property/6737460151191502/01a03eb3-89f3-7537-a071-43170e135c28.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJB2rAhSov9ocRkTV4eHzT0ys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_3fbbc75c-c99d-4bab-a121-eea4c8a45c0b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Uptown Transit Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Minneapolis, MN 55408, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-7721-727f-8c47-2151a2331896.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-7721-727f-8c47-2151a2331896",
        "storage_key": "property/6737460151191502/01a03eb3-7721-727f-8c47-2151a2331896.webp",
        "width": 1280,
        "height": 684
      },
      "poi_business_url": "http://www.metrotransit.org/uptown-transit-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=15379628613307455673&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uptown-transit-station",
      "poi_latitude": "44.9500785",
      "poi_longitude": "-93.2978535",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 612-373-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-89dd-7428-9108-d8e3efa9e848.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03eb3-89dd-7428-9108-d8e3efa9e848",
        "storage_key": "property/6737460151191502/01a03eb3-89dd-7428-9108-d8e3efa9e848.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJBW8Fy4En9ocRudifMb1qb9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_77bd5bd6-5b3f-437d-8883-6264701b458a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Morrill Hall",
      "poi_type": "Education",
      "poi_address": "Morrill Hall, 100 Church St SE, Minneapolis, MN 55455, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-7b18-77b3-abeb-7262f15cff35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-7b18-77b3-abeb-7262f15cff35",
        "storage_key": "property/6737460151191502/01a03eb3-7b18-77b3-abeb-7262f15cff35.webp",
        "width": 1280,
        "height": 834
      },
      "poi_business_url": "https://campusmaps.umn.edu/morrill-hall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6254071524483979566&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morrill-hall",
      "poi_latitude": "44.9758905",
      "poi_longitude": "-93.2346317",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 612-625-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-ba66-770b-bd71-f12e94f457d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-ba66-770b-bd71-f12e94f457d0",
        "storage_key": "property/6737460151191502/019d01a7-ba66-770b-bd71-f12e94f457d0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK1KnkhYts1IRLtnAgOrsylY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b2bc52ff-8e09-4862-9c4d-95d3e7795928",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "M Health Fairview University of Minnesota Medical Center - East Bank",
      "poi_type": "Health and Wellness",
      "poi_address": "500 SE Harvard St, Minneapolis, MN 55455, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-7ac5-743a-aa35-a80e1d85f074.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-7ac5-743a-aa35-a80e1d85f074",
        "storage_key": "property/6737460151191502/01a03eb3-7ac5-743a-aa35-a80e1d85f074.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://mhealthfairview.org/locations/m-health-fairview-university-of-minnesota-medical-center---east-bank",
      "poi_directions_map_url": "https://maps.google.com/?cid=15715049760007388325&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "m-health-fairview-university-of-minnesota-medical-center---east-bank",
      "poi_latitude": "44.97120700000001",
      "poi_longitude": "-93.230731",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 612-273-8383",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-bea3-7416-b7cf-56b209ce7593.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-bea3-7416-b7cf-56b209ce7593",
        "storage_key": "property/6737460151191502/019d01a7-bea3-7416-b7cf-56b209ce7593.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJO8cyHz0ts1IRpfzTrH4SF9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_7915065b-b15b-4fb3-85b5-0ade772400c6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "M Health Fairview University of Minnesota Medical Center - West Bank",
      "poi_type": "Health and Wellness",
      "poi_address": "2450 Riverside Ave, Minneapolis, MN 55454, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-7e8c-765d-bd66-99022dbd29ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-7e8c-765d-bd66-99022dbd29ad",
        "storage_key": "property/6737460151191502/01a03eb3-7e8c-765d-bd66-99022dbd29ad.webp",
        "width": 1280,
        "height": 948
      },
      "poi_business_url": "https://www.mhealthfairview.org/locations/M-Health-Fairview-University-of-Minnesota-Medical-Center---West-Bank-east",
      "poi_directions_map_url": "https://maps.google.com/?cid=4950063888007043985&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "m-health-fairview-university-of-minnesota-medical-center---west-bank",
      "poi_latitude": "44.9675165",
      "poi_longitude": "-93.23769500000002",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 612-672-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-bea3-7416-b7cf-56b209ce7593.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-bea3-7416-b7cf-56b209ce7593",
        "storage_key": "property/6737460151191502/019d01a7-bea3-7416-b7cf-56b209ce7593.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJAf7GITkts1IRkRsmLOEoskQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_ffbcdd38-1e43-4639-81c9-e98e8784ac58",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "M Health Fairview Masonic Children's Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2450 Riverside Ave, Minneapolis, MN 55454, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-829d-775d-ae40-d341742563a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-829d-775d-ae40-d341742563a5",
        "storage_key": "property/6737460151191502/01a03eb3-829d-775d-ae40-d341742563a5.webp",
        "width": 1280,
        "height": 807
      },
      "poi_business_url": "https://www.mhealthfairviewpeds.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17504372724993765568&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "m-health-fairview-masonic-childrens-hospital",
      "poi_latitude": "44.966713",
      "poi_longitude": "-93.2372371",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 612-365-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-bea3-7416-b7cf-56b209ce7593.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-bea3-7416-b7cf-56b209ce7593",
        "storage_key": "property/6737460151191502/019d01a7-bea3-7416-b7cf-56b209ce7593.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJnxM5Kj0ts1IRwDBKUUAG7PI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_374bd7f7-9451-4f03-8400-6d5bf2547644",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "U.S. Bank Branch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "800 Nicollet Mall, Minneapolis, MN 55402, USA",
      "poi_short_description": "Cash advances and other financial services are available at this branch of a national bank chain.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-7c48-7518-a9b3-b33dfbf86fad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-7c48-7518-a9b3-b33dfbf86fad",
        "storage_key": "property/6737460151191502/01a03eb3-7c48-7518-a9b3-b33dfbf86fad.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.usbank.com/locations/minnesota/minneapolis/800-nicollet-mall-bank-atm/?utm_source=google&utm_medium=organic&utm_campaign=gbp_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=9848271995717534090&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "us-bank-branch",
      "poi_latitude": "44.9755906",
      "poi_longitude": "-93.2738748",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 612-659-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-89e0-7409-b91b-48343759b06b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03eb3-89e0-7409-b91b-48343759b06b",
        "storage_key": "property/6737460151191502/01a03eb3-89e0-7409-b91b-48343759b06b.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJe6Jb3ZYys1IRisErpDMXrIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bank"
    },
    {
      "id": "custom_e305dbe9-97d2-41cc-a54c-aa4921327fa6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Target Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1000 Nicollet Mall, Minneapolis, MN 55403, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb0-f129-7340-bb59-183b3a4ac543.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb0-f129-7340-bb59-183b3a4ac543",
        "storage_key": "property/6737460151191502/01a03eb0-f129-7340-bb59-183b3a4ac543.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.target.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12859972463573983574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target-corporation",
      "poi_latitude": "44.9739975",
      "poi_longitude": "-93.2753023",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 612-304-6073",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAe5o1pUys1IRVuGhENLMd7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0a2195c4-ed61-4f2a-9264-f4e7986e5865",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Allina Health",
      "poi_type": "Health and Wellness",
      "poi_address": "The Commons, 2925 Chicago Ave, Minneapolis, MN 55407, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-7f64-72cb-9138-d2e55ce3943a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-7f64-72cb-9138-d2e55ce3943a",
        "storage_key": "property/6737460151191502/01a03eb3-7f64-72cb-9138-d2e55ce3943a.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://www.allinahealth.org/?utm_source=gmb&utm_medium=organic&utm_content=web-url&utm_campaign=gmb_website&utm_term=allina-health",
      "poi_directions_map_url": "https://maps.google.com/?cid=11959276386783343014&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allina-health",
      "poi_latitude": "44.9493365",
      "poi_longitude": "-93.2603976",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 612-262-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOzhUd_4n9ocRpjHwxILi96U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_88b6eb16-7b57-4a14-b3bf-41f9fea7968d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Minneapolis VA Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1 Veterans Dr, Minneapolis, MN 55417, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb3-8216-7399-a18f-83657a62db1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb3-8216-7399-a18f-83657a62db1a",
        "storage_key": "property/6737460151191502/01a03eb3-8216-7399-a18f-83657a62db1a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.va.gov/minneapolis-health-care/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3642700861927343425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minneapolis-va-medical-center",
      "poi_latitude": "44.9018834",
      "poi_longitude": "-93.2048785",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 612-725-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-bea3-7416-b7cf-56b209ce7593.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-bea3-7416-b7cf-56b209ce7593",
        "storage_key": "property/6737460151191502/019d01a7-bea3-7416-b7cf-56b209ce7593.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJTbNHjhYp9ocRQUUwUiJ5jTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_5db7c4cd-a818-49c5-9994-56a1e7340247",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "poi_name": "Ameriprise Financial Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "901 3rd Ave S, Minneapolis, MN 55402, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb0-e87a-765d-a43a-a574948e266b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03eb0-e87a-765d-a43a-a574948e266b",
        "storage_key": "property/6737460151191502/01a03eb0-e87a-765d-a43a-a574948e266b.webp",
        "width": 1280,
        "height": 885
      },
      "poi_business_url": "https://www.ameriprise.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7494088706523804793&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ameriprise-financial-center",
      "poi_latitude": "44.972609",
      "poi_longitude": "-93.2697421",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 612-671-3131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a7-be3d-740c-8416-4c81538244cf",
        "storage_key": "property/6737460151191502/019d01a7-be3d-740c-8416-4c81538244cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ42nwvpkys1IReTSeI_lZAGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_3a78ba82c13ff3749bef40cf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_fa0e4f75f497d3fec0ebdf99",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_c0f45ecfccdd4f6609551775",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_4a336e739199429cb5bdf061",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_384d1a64da8d8c6a18afded9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_28de9707dad7506c6af16f63",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "day": "SAT",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_fa09e7abd3209b3793cd2941",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "rating": "5",
      "name": "Dom",
      "text": "LOVE IT HERE!!!\n\nFrom the initial inquiry through the move-in process, the LPM leasing team has been phenomenal. I move frequently and have lived all over the country, and I can honestly say this has been the most organized, efficient, courteous, proactive and customer-focused leasing team I’ve had the pleasure of working with.\n\nI primarily worked with Adam, John, and Tim during my move-in process, and Tony was wonderful as well. They were incredibly accommodating and truly great to work with. The concierge, Pelle, has also been amazing. I call this group of gentlemen the “Fantastic 5”! Great job to mgmt. who hired these guys. I hope they are being paid well :)\n\nNow, let’s get into the apartment and amenities — LOVE, LOVE, LOVE. From the spacious units and incredible views to the coffee, automatic doors (which make a huge difference when walking your dog or carrying large items), pools, fitness room, and everything in between — this place is exceptional.\n\nYou will absolutely love living here. As long as the pricing remains around the same, I can definitely see myself staying here for years to come.",
      "date": "2026-05-26",
      "title": "false"
    },
    {
      "id": "ec_c42a229632f6ccb2454fa22e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "rating": "5",
      "name": "Felecia Lockett",
      "text": "We could not be happier with my daughter’s experience at LPM so far!\nFrom the very first apartment showing to signing the lease and finally moving in, the entire process has been absolutely fantastic.\nLPM is truly a beautiful building, and from day one we felt welcomed by both the staff and the community atmosphere.\nThe apartments are stunning, and the floor-to-ceiling windows bring in incredible natural light that completely transforms the space. It instantly felt like somewhere she could truly call home.\n\nOne thing that really stood out throughout this process was the exceptional leasing experience.\nHuge shout out to Adam, Tim, John, and Tony! They made every step seamless and went above and beyond to answer questions, accommodate requests, and ensure my daughter felt comfortable and excited throughout the process.\nTheir kindness, professionalism, and down-to-earth personalities made what can often be a stressful transition genuinely enjoyable.\n\nWe are also excited about all of the community events and opportunities to connect with other residents. It’s clear LPM values creating a welcoming and engaging environment.\nLoring Park itself is such an amazing neighborhood — beautiful green space, tons of nature, and somehow right in the middle of the city. You truly get the best of both worlds.\n\nMy daughter is extremely particular, and LPM checked every box: beautiful space, welcoming environment, great location, and a team that genuinely cares.\nIf you're looking for a comfortable, inviting, safe apartment community where people truly go the extra mile, I highly recommend LPM!",
      "date": "2026-05-21",
      "title": "false"
    },
    {
      "id": "ec_e95bdb59a9d3bd4eae5e2b4b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "rating": "5",
      "name": "Mike Ketcham",
      "text": "We absolutely love the view from our\napartment! Especially spacious walk in closet with the shelving. We've been here for 11 years now and have continued loving it here. My wife and I are both 86 and couldnt feel more comfortable with this community! Everybody is extremely helpful and welcoming.",
      "date": "2026-05-07",
      "title": "false"
    },
    {
      "id": "ec_20c6e65ada7e38b5e6ac43a5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "rating": "5",
      "name": "Jaylin Tuman",
      "text": "I have lived at LPM for about a month and have been very happy with my experience so far. Adam made the move-in process seamless and was incredibly helpful. My apartment has been great with no issues to date. The floor-to-ceiling windows are incredible and there is amazing natural light throughout my whole apartment. Would highly recommend LPM to anyone looking for a great place to live.",
      "date": "2026-06-25",
      "title": "false"
    },
    {
      "id": "ec_d0f3a16d167260ec8c742842",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "rating": "5",
      "name": "Gavin Victor",
      "text": "I’ve lived in quite a few places in my 43 years, but I have never loved an apartment or a home as much as I do the one at LPM in Loring Park, Minnesota. The amenities all indoor and outdoor the beautiful views all glass walls updated appliances, one of the newest buildings in the cities make it so unique and help me use the amenities more than anything I’ve ever used in all of the residences I’ve had in the past combined. But what really makes this property is the staff. They are the best in the business. Weidner who owns the property is famous for come again in revamping and turning around situations that are less than favorable and after Covid, they’ve done so in so many companies around the Twin Cities that they have become the dominating force and rehabilitating properties and homes. Even though they are a large corporate company, they still allow their employees to treat each of their residence like family. If anything is ever wrong ever needs to be fixed if any situation comes up. They are more than willing. No they’re happy to do everything they can to help. Typically with large corporations, you lose that personal touch, but the leasing office, the agents even the directors know most of the residence by name. It’s these policies that make all the difference in the world as a business owner myself I really respect and know how much time and money it takes to maintain something as well as they do the director Toni is amazing and the managers in training and leasing agents and Concierge  from Adam to Andrew to Mitch in security everyone is top notch! I couldn’t recommend this property more. It will be the best thing you ever did.",
      "date": "2026-04-06",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_06cc0158-f6e6-45ff-939b-d19256af778f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191502/01a03eb0-9f83-752c-bd4a-ccb873bc683e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03eb0-9f83-752c-bd4a-ccb873bc683e",
        "storage_key": "property/6737460151191502/01a03eb0-9f83-752c-bd4a-ccb873bc683e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "LPM Apartments #1408",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=CyxKdUxKiCv"
    }
  ],
  "faqs": [
    {
      "id": "custom_87084077-0b3a-469b-b32d-31e6d10a4c4d",
      "question": "Does LPM Apartment Homes have a fitness center?",
      "answer": "Yes. LPM Apartment Homes has a state-of-the-art fitness center as part of its 40,000 square feet of community space.",
      "category": "Amenities",
      "source": "custom"
    }
  ],
  "fees": [
    {
      "id": "ec_ecf3af4adb1b11564ac1bcba",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "a1a97f57ece10c49",
      "name": "NSF Tenant Fee",
      "description": "NSF Tenant Fee",
      "amount": 30,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Lease",
      "charge_code": "nsff",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_ed423c955507405b8a69d56b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "dc8adfadb0a1aaf6",
      "name": "Late Fee",
      "description": "Late Fee",
      "amount": 8,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per Lease",
      "category": "Lease",
      "charge_code": "late",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_691a53aba110c166774eae62",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "cea07e4fca0e1bff",
      "name": "Lease Termination Fee",
      "description": "Lease Termination Fee",
      "amount": 100,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per Lease",
      "category": "Term",
      "charge_code": "term",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c10801caf28b0db8271207b4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "3faabaa67cff1d97",
      "name": "Transfer Fee",
      "description": "Transfer Fee",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Transfer",
      "charge_code": "tran",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_fb92d26bff00e76d5ce8aaf8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "da0f3184cbbf9893",
      "name": "Water Charge",
      "description": "Water Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage based, paid monthly",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubwater",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_fee1990c40936f0681a94846",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "135bd527c15aa0ce",
      "name": "Sewer Charge",
      "description": "Sewer Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage based, paid monthly",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubsewer",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_461d2f5bd0ce5718da757d8e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "ec8a7d9e0f8ff30d",
      "name": "Electric Charge",
      "description": "Electric Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage based, paid monthly",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "elec",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_19ecfb0abcb57ded968270d6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "8ec1c4fb2a86979c",
      "name": "Utility Billing Admin Fee",
      "description": "Utility Billing Admin Fee",
      "amount": 8,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubadmin",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_10584d682b2ddb8ec83ded02",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "a414ecc4b762ea6e",
      "name": "Gas Charge",
      "description": "Gas Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage based, paid monthly",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "gasc",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_83f9cf34a3c6cc93b458c91a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "18d6b18141264533",
      "name": "Trash Charge",
      "description": "Trash Utility Charge – Based on Square Footage and Occupancy",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally distributed",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubtrash",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_9250a65ded0e4a6637d5e025",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "29d0baf9b2589256",
      "name": "Pet Screening Fee",
      "description": "Pet Screening Fee - $30 for Card Payments, $25 for ACH Payments. No cost for verified Service Animals.",
      "amount": 25,
      "amount_max": 30,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Move-In",
      "category": "Pet",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [
    {
      "id": "ec_0de7e91f94c936802135c8f6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "2467949",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 300,
      "fee": 300,
      "monthly_rent": 40,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "false"
    },
    {
      "id": "ec_9c3542a8a0be155af5fc5889",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "yardi",
      "external_id": "2467948",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 300,
      "fee": 300,
      "monthly_rent": 40,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "Breed restrictions apply"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa47-aa3a-71aa-a47f-4037e9ffa6c4",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "lpm-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502"
    },
    {
      "lead_collector_id": "0198aa47-aa9d-7156-8043-417765236bbc",
      "lead_source": "FACEBOOK_ADS",
      "name": "lpm-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502"
    },
    {
      "lead_collector_id": "0198aa47-aaff-73dd-a3e2-e89a84e7e333",
      "lead_source": "LANDING_PAGE",
      "name": "lpm-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "luxury-apartments-pool-minneapolis",
      "search_query": "luxury apartments with pool minneapolis",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Minneapolis",
      "h2_subtitle": "Discover premier luxury apartments with pool access in Minneapolis. LPM Apartments offers top-tier amenities in a prime location.",
      "page_copy": "Experience the pinnacle of style and comfort at LPM Apartments, featuring luxury apartments with pool facilities right in the heart of Minneapolis. Nestled in the bustling Loring Park neighborhood, our residences connect you seamlessly to North Loop and Uptown. Our top-floor units provide stunning views, complemented by elegant drapes.\n\nLPM Apartments boasts a range of upscale amenities, including a stylish clubhouse, a state-of-the-art media center, and a well-equipped bicycle workshop. Relax by the pool or schedule a tour to see why our community is the epitome of luxury living in Central Minneapolis.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool - Minneapolis",
      "seo_description": "Find luxury Minneapolis apartments with a pool at LPM Apartments, nestled between North Loop and Uptown. Enjoy top amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-loring-park-mn",
      "search_query": "dog friendly apartments loring park mn",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments in Loring Park, MN",
      "h2_subtitle": "Find the perfect dog-friendly apartment in Loring Park, MN. LPM Apartments welcomes pets and offers great amenities.",
      "page_copy": "LPM Apartments is the perfect home for you and your furry friends, offering dog-friendly apartments in the vibrant Loring Park neighborhood of Minneapolis, MN. With easy access to beautiful parks and pet-friendly paths, our community is ideal for pet owners who want convenience and luxury.\n\nOur location bridges North Loop and Uptown, providing not just a pet-welcoming environment but also proximity to the city's hotspots. Residents enjoy standout amenities like a spacious top floor, elegant drapes, a social clubhouse, and a convenient media center. Discover a home where both you and your pets will thrive at LPM Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments - Loring Park, MN",
      "seo_description": "Explore dog-friendly living at LPM Apartments in Loring Park, MN. Perfect for pet owners, with great amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartment-central-minneapolis",
      "search_query": "in-unit laundry apartment in central minneapolis",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Central Minneapolis",
      "h2_subtitle": "Convenience meets luxury with in-unit laundry at LPM Apartments. Located in Central Minneapolis, enjoy top-tier living.",
      "page_copy": "Experience the ultimate convenience of in-unit laundry at LPM Apartments, located in the heart of Central Minneapolis. Our luxurious apartments combine modern convenience with a prime urban setting, making everyday living easier and more enjoyable.\n\nSituated between the lively neighborhoods of North Loop and Uptown, LPM Apartments provide more than just a premier location. Residents can also enjoy an array of amenities, including a top-floor with breathtaking views, elegant drapes, a vibrant clubhouse, and a media center/movie theatre. Live comfortably and stylishly at our Central Minneapolis community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments - Central Minneapolis",
      "seo_description": "Find the perfect apartment with in-unit laundry in Central Minneapolis at LPM Apartments, featuring modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "spacious-walk-in-closets-apartments-hennepin-county",
      "search_query": "spacious walk-in closets apartments hennepin county",
      "category": "Amenity",
      "h1_title": "Spacious Walk-In Closets in Hennepin County",
      "h2_subtitle": "Discover apartments with spacious walk-in closets in Hennepin County. LPM Apartments offers stylish living in a prime location.",
      "page_copy": "LPM Apartments offers the ideal living experience with spacious walk-in closets in the desirable Hennepin County area. Enhance your lifestyle with generous storage solutions in our luxurious Minneapolis apartments, designed to suit both comfort and style.\n\nLocated in vibrant Loring Park, between the energetic North Loop and Uptown neighborhoods, our community makes it easy to enjoy city living at its finest. Alongside expansive closets, residents have access to exceptional amenities such as a top-floor retreat, elegant drapes, a clubhouse, and a premium media center/movie theatre. Experience the ideal blend of functionality and luxury at LPM Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Walk-In Closets - Hennepin County",
      "seo_description": "Explore LPM Apartments in Hennepin County with spacious walk-in closets and premium amenities, perfectly located in Central Minneapolis.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "apartments-with-air-conditioning-minneapolis-mn",
      "search_query": "apartments with air conditioning minneapolis mn",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Minneapolis, MN",
      "h2_subtitle": "Stay comfortable year-round in air conditioned apartments at LPM in Minneapolis, MN. Enjoy luxury living and prime location.",
      "page_copy": "Stay cool and comfortable at LPM Apartments, where we offer air-conditioned accommodations in the heart of Minneapolis, MN. Our modern apartments are designed to provide relief from seasonal changes while ensuring you enjoy luxurious living.\n\nLocated in vibrant Loring Park, you'll be at the nexus of the North Loop and Uptown neighborhoods. Our residents not only enjoy air-conditioned comfort but also access to outstanding amenities such as a top-floor oasis, stylish drapes, a lively clubhouse, and a state-of-the-art media center. Discover your ideal home in a thriving community at LPM Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments - Minneapolis, MN",
      "seo_description": "Find air conditioned apartments at LPM in Minneapolis, MN. Enjoy luxury living, excellent amenities, and a prime location in Central Minneapolis.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "studio-apartments-central-minneapolis",
      "search_query": "studio apartments central minneapolis",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Central Minneapolis",
      "h2_subtitle": "Discover stylish studio apartments in Central Minneapolis at LPM. Enjoy vibrant living in a prime location.",
      "page_copy": "Find your perfect home at LPM Apartments, where our chic studio apartments in Central Minneapolis meet modern living needs with style and function. Positioned in lively Loring Park, you’ll enjoy the best of urban life, close to exciting areas like North Loop and Uptown.\n\nOur studio apartments blend space efficiency with top-notch amenities, offering comfort and convenience. Residents take advantage of features like drapes for privacy, a top-floor with stunning views, a social clubhouse, and a media center/movie theatre. LPM Apartments provide everything you need for a fulfilling lifestyle in the heart of the city.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments - Central Minneapolis",
      "seo_description": "Explore spacious studio apartments at LPM in Central Minneapolis. Enjoy urban living and extensive amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-hennepin-county",
      "search_query": "one bedroom apartments hennepin county",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Hennepin County",
      "h2_subtitle": "Explore one bedroom apartments at LPM in Hennepin County. Stylish living in a vibrant Minneapolis location awaits you.",
      "page_copy": "LPM Apartments offers exceptional one bedroom apartments in the heart of Hennepin County. Perfect for those seeking both comfort and style, our units are ideal for living in the thriving Minneapolis area.\n\nSet in the lively Loring Park neighborhood, our one bedroom apartments provide access to the best of city living. Enjoy exceptional amenities such as a top-floor retreat, privacy-enhancing drapes, a community-focused clubhouse, and a modern media center/movie theatre. Located between North Loop and Uptown, LPM Apartments is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments - Hennepin County",
      "seo_description": "Find your next home at LPM's one bedroom apartments in Hennepin County. Enjoy luxury living in vibrant Minneapolis.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-minneapolis-mn",
      "search_query": "two bedroom apartments minneapolis mn",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Minneapolis, MN",
      "h2_subtitle": "Discover spacious two bedroom apartments at LPM in Minneapolis, MN. Experience luxury living in vibrant Loring Park.",
      "page_copy": "Explore spacious two bedroom apartments at LPM Apartments, where modern design meets prime location in Minneapolis, MN. Our units offer the perfect blend of style and functionality, making them ideal for roommates or small families.\n\nLocated in Loring Park, our community connects you to Minneapolis's best, including North Loop and Uptown. With amenities like a top-floor viewing deck, clubhouse, drapes for added privacy, and a media center/movie theatre, LPM Apartments promises a lifestyle of convenience and luxury. Discover the perfect two bedroom living experience at LPM.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments - Minneapolis, MN",
      "seo_description": "Find luxury two bedroom apartments at LPM in Minneapolis, MN. Enjoy spacious layouts and top amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "three-bedroom-rentals-loring-park",
      "search_query": "three bedroom rentals loring park",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Rentals in Loring Park",
      "h2_subtitle": "Explore three bedroom rentals at LPM in Loring Park. Enjoy spacious living in a vibrant Minneapolis neighborhood.",
      "page_copy": "Discover generous three bedroom rentals at LPM Apartments, ideally situated in the heart of Loring Park. Perfect for families or those seeking extra space, our well-designed units offer a comfortable Minneapolis lifestyle.\n\nPositioned between North Loop and Uptown, our Loring Park community provides easy access to the city's attractions. Enjoy amenities like a premium top-floor view, community clubhouse, privacy-enhancing drapes, and a media center/movie theatre. LPM Apartments in Loring Park is where sophisticated living meets urban convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Rentals - Loring Park",
      "seo_description": "Find spacious three bedroom rentals at LPM in Loring Park. Perfect for families, enjoy urban living with top amenities in Minneapolis.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "luxury-apartments-near-minneapolis-college",
      "search_query": "luxury apartments near Minneapolis College",
      "category": "School",
      "h1_title": "Luxury Apartments Near Minneapolis College",
      "h2_subtitle": "Discover luxury apartments at LPM near Minneapolis College. Enjoy elegant living in the central Minneapolis area.",
      "page_copy": "LPM Apartments offers luxury living near Minneapolis College, providing students and faculty elegant accommodations in a prime location. Our premier units boast sophisticated finishes and modern amenities, making them the perfect choice for those seeking comfort and convenience.\n\nSituated in the lively Loring Park neighborhood, LPM Apartments places you close to the academic action while enjoying luxury amenities. Whether you choose to unwind at our top-floor deck, host friends in the clubhouse, or watch movies in the media center/movie theatre, LPM provides the ideal lifestyle solution near Minneapolis College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments - Near Minneapolis College",
      "seo_description": "Experience luxury living at LPM Apartments near Minneapolis College. Enjoy stylish accommodations in central Minneapolis.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "apartments-by-fair-school-for-arts-central-mpls",
      "search_query": "apartments by FAIR School for Arts Central Minneapolis",
      "category": "School",
      "h1_title": "Apartments Near FAIR School for Arts",
      "h2_subtitle": "Discover ideal apartments by FAIR School for Arts in Central Minneapolis. Enjoy proximity and exceptional amenities at LPM Apartments.",
      "page_copy": "Experience the convenience of living near the FAIR School for Arts by choosing LPM Apartments in Central Minneapolis. Our stylish rentals offer the perfect solution for families and students seeking quality accommodations close to the school.\n\nNestled in the picturesque Loring Park area, LPM Apartments connectors residents with both cultural and educational landmarks. Enjoy amenities such as a top-floor viewing area, club meeting spaces, beautiful drapes, a bicycle workshop, and a media/movie theatre. Make LPM your home and embrace an enriching lifestyle near FAIR School for Arts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by FAIR School for Arts - Mpls",
      "seo_description": "Find perfect apartments near FAIR School for Arts at LPM in Central Minneapolis. Experience quality living with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "rentals-close-loring-nicollet-alt-school-mn",
      "search_query": "rentals close to Loring Nicollet Alternative School MN",
      "category": "School",
      "h1_title": "Rentals Near Loring Nicollet Alt School MN",
      "h2_subtitle": "Find rentals close to Loring Nicollet Alternative School in Minnesota. Enjoy convenience and quality living at LPM Apartments.",
      "page_copy": "Choose LPM Apartments for spacious rentals located close to Loring Nicollet Alternative School in Minnesota. Our well-appointed units are perfect for students and families seeking proximity to the educational institution, along with the flexibility and modern amenities they need.\n\nSituated in the dynamic Loring Park neighborhood of Minneapolis, LPM offers more than just a place to live. Residents can personalize their lifestyle with our top-floor views, meet up in the community clubhouse, enjoy privacy with our drapes, and catch a film in the media center/movie theatre. Come experience the ideal blend of convenience and luxury at LPM Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to Loring Nicollet Alt School MN",
      "seo_description": "Discover rentals close to Loring Nicollet Alternative School at LPM Apartments in MN. Enjoy quality and convenience in the heart of Minneapolis.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "apartments-near-mnic-high-school-downtown-hennepin",
      "search_query": "apartments near MNIC High School Downtown Campus Hennepin County",
      "category": "School",
      "h1_title": "Apartments Near MNIC High School Downtown",
      "h2_subtitle": "Explore apartments near MNIC High School's downtown campus in Hennepin County. Experience premier living at LPM Apartments.",
      "page_copy": "LPM Apartments offers a unique living experience near MNIC High School's downtown campus located in vibrant Hennepin County. Our luxurious units provide easy access for students and staff who wish to live close by while enjoying an upscale residence.\n\nLocated in the heart of Central Minneapolis, LPM Apartments feature top-tier amenities such as a sophisticated clubhouse, bicycle workshop, and a dedicated space for media and movies. Living here means you'll be steps away from educational opportunities while indulging in an environment that prioritizes comfort and modern luxury.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apt Near MNIC High School Downtown Campus",
      "seo_description": "Discover LPM Apartments near MNIC High School Downtown Campus in Hennepin County. Enjoy luxury living and easy access to education.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "living-options-near-morrill-hall-minneapolis",
      "search_query": "living options near Morrill Hall Minneapolis",
      "category": "School",
      "h1_title": "Living Options Near Morrill Hall",
      "h2_subtitle": "Explore living options near Morrill Hall in Minneapolis. Discover luxury and convenience with LPM Apartments' prime location.",
      "page_copy": "Located just a short distance from Morrill Hall, LPM Apartments provides superb living options in Minneapolis. Our state-of-the-art residences offer the perfect blend of proximity and style for those affiliated with nearby educational institutions.\n\nSituated in the picturesque Loring Park area, LPM Apartments offers residents access to a wealth of amenities such as a scenic top floor, convenient drapes, community clubhouse, bike workshop, and a media/movie theatre. Whether you're a student or a professional, our vibrant community near Morrill Hall ensures you'll enjoy a luxurious and convenient urban lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Options Near Morrill Hall - Minneapolis",
      "seo_description": "Find luxury living options near Morrill Hall in Minneapolis at LPM Apartments. Enjoy close proximity and top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "apartments-near-m-health-fairview-medical-center",
      "search_query": "apartments near M Health Fairview University of Minnesota Medical Center East Bank",
      "category": "Hospital",
      "h1_title": "Apartments Near M Health Fairview East Bank",
      "h2_subtitle": "Discover apartments near M Health Fairview University of Minnesota Medical Center East Bank. Experience convenient living at LPM Apartments.",
      "page_copy": "LPM Apartments offers exceptional accommodations near the M Health Fairview University of Minnesota Medical Center East Bank. Our prime location ensures that medical professionals, patients, or students can enjoy comfort and convenience all in one place.\n\nNestled in the lively heart of Minneapolis, our community provides residents with an array of amenities, including a top floor with stunning views, a clubhouse for social gatherings, and a media center/movie theatre for entertainment. With LPM Apartments, enjoy easy access to healthcare facilities and an upscale lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apt Near M Health Fairview East Bank",
      "seo_description": "Live near M Health Fairview University of Minnesota Medical Center East Bank at LPM Apartments. Luxury and convenience in one location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "apartments-close-to-mh-fairview-west-bank",
      "search_query": "apartments close to M Health Fairview University of Minnesota Medical Center West Bank Minneapolis",
      "category": "Hospital",
      "h1_title": "Apartments Close to M Health Fairview West Bank",
      "h2_subtitle": "Find the perfect apartment close to M Health Fairview University of Minnesota Medical Center West Bank in Minneapolis at LPM Apartments.",
      "page_copy": "If you're seeking residences close to the M Health Fairview University of Minnesota Medical Center West Bank, LPM Apartments is your ideal choice. Our location in Central Minneapolis offers quick and easy access to the medical center, allowing healthcare professionals, students, and families to connect effortlessly with their daily destinations.\n\nStep into luxury with amenities such as a stylish clubhouse, engaging media center/movie theatre, and a bike workshop, making LPM Apartments not just a living space, but a vibrant community. From our centrally located spot, experience the best of urban living while being only moments away from the West Bank campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apt Close to M Health Fairview West Bank",
      "seo_description": "Discover luxury apartments close to M Health Fairview University of Minnesota Medical Center West Bank at LPM Apartments in Minneapolis.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "apartments-near-m-health-fairview-masonic-childrens",
      "search_query": "apartments near M Health Fairview Masonic Children's Hospital Hennepin County",
      "category": "Hospital",
      "h1_title": "Apartments Near Masonic Children's Hospital",
      "h2_subtitle": "Explore apartments near M Health Fairview Masonic Children's Hospital in Hennepin County. LPM Apartments offers unparalleled convenience and luxury.",
      "page_copy": "LPM Apartments, located in the vibrant area of Central Minneapolis, provides exceptional living spaces near M Health Fairview Masonic Children's Hospital. For medical professionals, families, or anyone connected with the hospital, our location offers seamless accessibility.\n\nDiscover a world of comfort and convenience with amenities including a sophisticated clubhouse, a media center/movie theatre for relaxation, and a specialized bicycle workshop. Offering a prime location in Hennepin County, LPM Apartments ensures that you can enjoy both the tranquility of home and the excitement of city life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apt Near Masonic Children's Hospital",
      "seo_description": "Live near M Health Fairview Masonic Children's Hospital in Hennepin County at LPM Apartments. Enjoy luxury and proximity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "rentals-near-minneapolis-va-medical-center",
      "search_query": "rentals near Minneapolis VA Medical Center Central Minneapolis",
      "category": "Hospital",
      "h1_title": "Rentals Near Minneapolis VA Medical Center",
      "h2_subtitle": "Find rentals near the Minneapolis VA Medical Center in Central Minneapolis. Enjoy convenient living at LPM Apartments.",
      "page_copy": "For those looking for rentals near the Minneapolis VA Medical Center, LPM Apartments offers the perfect solution in Central Minneapolis. Our proximity to the VA Medical Center ensures that veterans, healthcare professionals, and staff can easily commute and be close to their places of work.\n\nLocated in the thriving heart of the city, LPM Apartments caters to all with first-rate amenities such as a welcoming clubhouse, a state-of-the-art media center/movie theatre, and engaging community spaces. Enjoy the dynamic neighborhood atmosphere while benefiting from quick access to the VA Medical Center and all that Minneapolis has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Minneapolis VA Medical Center",
      "seo_description": "Discover rentals near Minneapolis VA Medical Center in Central Minneapolis at LPM Apartments. Comfortable and convenient living awaits.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "apartments-near-loring-greenway",
      "search_query": "apartments near Loring Greenway Central Minneapolis",
      "category": "Park",
      "h1_title": "Apartments Near Loring Greenway",
      "h2_subtitle": "Experience living near the lush Loring Greenway in Central Minneapolis. Find your new home at LPM Apartments.",
      "page_copy": "Nestled in Central Minneapolis, LPM Apartments offers residences just moments away from the scenic Loring Greenway. This green oasis provides a tranquil escape in the heart of the city, making our location perfect for those who cherish nature without sacrificing urban amenities.\n\nAt LPM Apartments, enjoy luxurious features like a vibrant clubhouse, a media center/movie theatre, and a convenient bicycle workshop. Our prime location near Loring Greenway not only provides access to peaceful park-like settings but also places you right between the lively neighborhoods of North Loop and Uptown, ensuring you're always close to the city's most exciting offerings.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apt Near Loring Greenway, Minneapolis",
      "seo_description": "Live near Loring Greenway in Central Minneapolis at LPM Apartments. Experience nature and urban life combined.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "mill-ruins-park-apartments",
      "search_query": "Mill Ruins Park apartments Minneapolis",
      "category": "Park",
      "h1_title": "Mill Ruins Park Apartments Minneapolis",
      "h2_subtitle": "Discover apartments near Mill Ruins Park in Minneapolis at LPM Apartments. Enjoy city living with historic charm.",
      "page_copy": "Located strategically in Central Minneapolis, LPM Apartments offers a luxury living experience with easy access to the iconic Mill Ruins Park. Perfect for history enthusiasts and nature lovers alike, our apartments provide a unique blend of urban convenience and scenic beauty.\n\nLPM Apartments is equipped with modern amenities including a stylish clubhouse, a media center/movie theatre for entertainment, and a dedicated bicycle workshop. With easy access to the historical site of Mill Ruins Park, residents can immerse themselves in the rich history of Minneapolis while enjoying the vibrant lifestyle of the city.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mill Ruins Park Apts, Minneapolis",
      "seo_description": "Find apartments near Mill Ruins Park in Minneapolis at LPM Apartments. Enjoy historic charm and modern comforts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "water-works-park-rentals-55403",
      "search_query": "Water Works Park rentals in 55403",
      "category": "Park",
      "h1_title": "Water Works Park Rentals in 55403",
      "h2_subtitle": "Explore rentals near Water Works Park in the 55403 area. LPM Apartments offers luxury living in Central Minneapolis.",
      "page_copy": "LPM Apartments, situated in the vibrant 55403 zip code, provides the ideal living experience near Water Works Park. This newly revitalized area offers a unique blend of natural beauty, with stunning riverfront views, and contemporary city amenities.\n\nBy choosing LPM Apartments, you gain access to luxurious amenities, including a chic clubhouse and a media center/movie theatre, all while being minutes away from the serene atmosphere of Water Works Park. Experience the convenience of city living with the tranquility of parkside leisure right at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Water Works Park Rentals 55403",
      "seo_description": "Discover upscale rentals near Water Works Park in the 55403 zip at LPM Apartments. Experience exquisite living in Central Minneapolis.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "father-hennepin-bluff-park-living",
      "search_query": "Father Hennepin Bluff Park living Hennepin County",
      "category": "Park",
      "h1_title": "Father Hennepin Bluff Park Living",
      "h2_subtitle": "Experience living near Father Hennepin Bluff Park in Hennepin County. Enjoy urban life with natural landscapes at LPM Apartments.",
      "page_copy": "Experience luxurious living near Father Hennepin Bluff Park in Hennepin County with LPM Apartments. Known for its scenic views of the Mississippi River and idyllic walking paths, this park offers a perfect retreat just moments away from the excitement of city life.\n\nLPM Apartments provide a sophisticated lifestyle with amenities such as a modern clubhouse, a media center/movie theatre, and a bicycle workshop, ensuring all your leisure and fitness needs are met. Enjoy the seamless blend of nature and urban convenience offered by our prime location near Father Hennepin Bluff Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Father Hennepin Bluff Park",
      "seo_description": "Live near Father Hennepin Bluff Park in Hennepin County at LPM Apartments. Enjoy nature and city life combined.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "gold-medal-park-apartments-nearby",
      "search_query": "Gold Medal Park apartments close by",
      "category": "Park",
      "h1_title": "Apartments Near Gold Medal Park",
      "h2_subtitle": "Discover apartments close by Gold Medal Park in Minneapolis. Experience the perfect blend of city life and green spaces at LPM Apartments.",
      "page_copy": "LPM Apartments offer a prime location for those looking to live near the beautiful Gold Medal Park. This well-loved green space is known for its art installations and peaceful trails, providing an oasis in the heart of the city.\n\nSituated in Central Minneapolis, LPM Apartments feature luxurious amenities like top-floor views, stylish drapes, and a comfortable clubhouse. With Gold Medal Park just a short stroll away, residents can enjoy leisurely walks, scenic views, and the vibrant community activities this iconic park offers. Embrace the convenience and beauty of apartments near these lush, open spaces.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Gold Medal Park, Minneapolis",
      "seo_description": "Find spacious apartments near Gold Medal Park at LPM Apartments. Enjoy easy access to green parks and city amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "target-field-station-plaza-rentals",
      "search_query": "Target Field Station Plaza & Amphitheater nearby rentals",
      "category": "Park",
      "h1_title": "Rentals Near Target Field Station Plaza",
      "h2_subtitle": "Find nearby rentals at Target Field Station Plaza & Amphitheater. LPM Apartments offers modern living with prime access to vibrant city life.",
      "page_copy": "Discover luxurious rentals close to Target Field Station Plaza & Amphitheater at LPM Apartments. Located in Central Minneapolis, this area is bustling with energy and offers a seamless connection to city attractions and sporting events.\n\nBy choosing LPM Apartments, you enjoy not only proximity to a dynamic hub of entertainment and transportation but also a wealth of in-house amenities like a bicycle workshop and media center/movie theatre, enhancing your urban lifestyle experience. Savor the best of both leisure and accessibility with your new home just steps from Target Field Station Plaza.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Target Field Station Plaza",
      "seo_description": "Explore nearby rentals at Target Field Station Plaza & Amphitheater with LPM Apartments. Enjoy luxury living in Minneapolis.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "luxury-apartments-warehouse-district-hennepin",
      "search_query": "luxury apartments near warehouse district hennepin ave minneapolis",
      "category": "Transit",
      "h1_title": "Luxury Apts Near Warehouse District MPLS",
      "h2_subtitle": "Explore luxury apartments near the Warehouse District off Hennepin Ave. Enjoy upscale living at LPM Apartments in Central Minneapolis.",
      "page_copy": "Experience the epitome of luxury living at LPM Apartments, ideally located near the vibrant Warehouse District along Hennepin Ave in Minneapolis. Known for its rich cultural scene, diverse dining options, and bustling nightlife, the Warehouse District offers endless entertainment possibilities right at your doorstep.\n\nLPM Apartments offer deluxe amenities such as top-level dwellings, a modern media center/movie theatre, and a chic clubhouse, ensuring that you live in comfort and style. Situated between North Loop and Uptown, our location provides easy access to both work and leisure, making it the perfect retreat after enjoying all that the Warehouse District offers.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apts Near Warehouse District MPLS",
      "seo_description": "Discover luxury apartments near the Warehouse District on Hennepin Ave. Enjoy upscale living at LPM Apartments, Minneapolis.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "apartments-near-nicollet-mall-minnesota",
      "search_query": "apartments close to nicollet mall minnesota",
      "category": "Transit",
      "h1_title": "Apts Near Nicollet Mall in Minnesota",
      "h2_subtitle": "Find spacious apartments close to Nicollet Mall in Minnesota. Enjoy urban living at LPM Apartments in Central Minneapolis.",
      "page_copy": "Located just a short distance from Nicollet Mall, LPM Apartments offer both convenience and luxury in the heart of Minneapolis. Nicollet Mall is renowned for its lively atmosphere, offering an array of shopping, dining, and entertainment options in a pedestrian-friendly environment.\n\nLPM Apartments provide residents with upscale amenities such as a chic clubhouse, well-equipped media center/movie theatre, and top-floor vistas, ensuring a comfortable and stylish living experience. Embrace the unique blend of city life and residential tranquility with our apartments near Nicollet Mall, allowing you easy access to the city's bustling center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Nicollet Mall in Minnesota",
      "seo_description": "Explore luxurious apartments close to Nicollet Mall in Minnesota. Enjoy city living at LPM Apartments, Minneapolis.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "apartments-near-government-plaza-mn",
      "search_query": "apartments near government plaza central minneapolis",
      "category": "Transit",
      "h1_title": "Apts Near Government Plaza Minneapolis",
      "h2_subtitle": "Discover modern apartments near Government Plaza in Central Minneapolis. LPM Apartments offer a convenient, upscale living experience.",
      "page_copy": "LPM Apartments present an ideal location close to Government Plaza in Central Minneapolis, perfect for those looking for both convenience and luxury. Government Plaza is a central hub, making it easy to access public services as well as enjoy the vibrant urban lifestyle that Minneapolis offers.\n\nOur apartments provide residents with exceptional amenities such as elegant drapes, a bicycle workshop, and a state-of-the-art media center/movie theatre, ensuring a captivating living experience. Enjoy the benefit of being near Government Plaza while residing in a community that values comfort and sophisticated living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Government Plaza Minneapolis",
      "seo_description": "Find modern apartments near Government Plaza in Central Minneapolis. Experience upscale living at LPM Apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151191502",
      "source": "generator",
      "page_item_url": "rentals-near-msp-airport-hennepin-county",
      "search_query": "rentals near minneapolis-saint paul international airport hennepin county",
      "category": "Transit",
      "h1_title": "Rentals Near MSP Airport in Hennepin Co.",
      "h2_subtitle": "Discover convenient rentals near Minneapolis-Saint Paul International Airport in Hennepin County at LPM Apartments.",
      "page_copy": "LPM Apartments offer exceptional rentals located a convenient drive away from Minneapolis-Saint Paul International Airport, right in the heart of Hennepin County. Perfect for frequent travelers, our location ensures easy access to the airport while providing a serene, home-like retreat from the bustling city.\n\nOur luxury apartments feature top-floor views, stylish drapes, and a contemporary clubhouse to enhance your living experience. Positioned between exciting neighborhoods like North Loop and Uptown, LPM Apartments seamlessly blend accessibility with high-end comforts, making them an ideal choice near the major transport hub of Minneapolis-Saint Paul International Airport.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, bookshelf, and large windows with city views.",
        "public_id": "019d01a5-9efe-72ac-a45c-c954a5c99f4c",
        "storage_key": "property/6737460151191502/019d01a5-9efe-72ac-a45c-c954a5c99f4c.webp",
        "width": 2000,
        "height": 1295
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near MSP Airport in Hennepin Co.",
      "seo_description": "Find convenient rentals near Minneapolis-Saint Paul International Airport in Hennepin County at LPM Apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2999"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "4434210848"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=6124828616"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T45Z2BQ"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 7"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "afa24383-4ab0-4346-91ed-d32356bff319"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Weidner Classic"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/8f9519ec-be77-43e7-ba06-245ba11f0da7/app.js?property=8f9519ec-be77-43e7-ba06-245ba11f0da7&amp;propertyName=LPM Apartments&amp;channelUuid=e84c7746-f04f-11ed-8f38-42010aa8d42b\" defer=\"\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "15684310279"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/dqw9k06gpo9"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkVTbE0zcG93VjNmcVNMZWpKMHd5Y3c9PSIsInZhbHVlIjoibnVDVk8xUjJKZkE5NWZpZFdqaFY2dz09IiwibWFjIjoiMjA5NjczZWQ0YWJhODZiMWI1YzVjOTQ5MDYwNzM3NTI3MWYxMTkxYzVmNWRjODRmZmIxZjI1Yjg5ODYyOGIyMCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "2999",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "4434210848",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=6124828616",
  "custom_google_gtm_id": "GTM-T45Z2BQ",
  "custom_rollout_phase": "Phase 7",
  "custom_rentgrata_token": "afa24383-4ab0-4346-91ed-d32356bff319",
  "custom_vibesites_theme": "Weidner Classic",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/8f9519ec-be77-43e7-ba06-245ba11f0da7/app.js?property=8f9519ec-be77-43e7-ba06-245ba11f0da7&amp;propertyName=LPM Apartments&amp;channelUuid=e84c7746-f04f-11ed-8f38-42010aa8d42b\" defer=\"\"></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "15684310279",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/dqw9k06gpo9",
  "custom_website_subscription": "custom",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkVTbE0zcG93VjNmcVNMZWpKMHd5Y3c9PSIsInZhbHVlIjoibnVDVk8xUjJKZkE5NWZpZFdqaFY2dz09IiwibWFjIjoiMjA5NjczZWQ0YWJhODZiMWI1YzVjOTQ5MDYwNzM3NTI3MWYxMTkxYzVmNWRjODRmZmIxZjI1Yjg5ODYyOGIyMCJ9"
};

export const generatedAt = '2026-11-03T21:12:06.785Z';
